/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.9.0 (NJsonSchema v10.4.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const cache = {};
/**
 * This is the base class for all generated API classes.
 */
export class BaseClient {
    constructor(config) {
        this.config = config;
    }
    generateToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.config.accessToken) {
                return this.config.accessToken;
            }
            const response = yield fetch(`${this.config.baseUrl}/identity-server/connect/token`, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: `grant_type=client_credentials&client_id=${this.config.appName}:${this.config.clientId}&client_secret=${this.config.clientSecret}&scope: "squidex-api"`
            });
            const data = yield response.json();
            return data["access_token"];
        });
    }
    /**
     * Clears the access token to force it to generate a new one on the next request.
     */
    clearAccessToken() {
        this.accessToken = undefined;
    }
    fetch(url, init) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = `${this.config.clientId}_${this.config.clientSecret}`;
            if (cache[key]) {
                this.accessToken = cache[key];
            }
            else {
                this.accessToken = yield this.generateToken();
                cache[key] = this.accessToken;
            }
            if (init === null || init === undefined) {
                init = {};
            }
            init.headers = Object.assign({}, this.config.headers, init.headers);
            // @ts-ignore
            init.headers["Authorization"] = `Bearer ${this.accessToken}`;
            const response = yield fetch(url, init);
            if (response.status >= 200 && response.status < 300) {
                return response;
            }
            throw response;
        });
    }
}
;
export class UsersApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get the user resources.
     * @return User resources returned.
     */
    getUserResources() {
        let url_ = this.config.baseUrl + "/api/";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetUserResources(_response);
        });
    }
    processGetUserResources(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ResourcesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get users by query.
     * @param query (optional) The query to search the user by email address. Case invariant.
     * @return Users returned.
     */
    getUsers(query) {
        let url_ = this.config.baseUrl + "/api/users?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetUsers(_response);
        });
    }
    processGetUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(UserDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get user by id.
     * @param id The id of the user (GUID).
     * @return User found.
     */
    getUser(id) {
        let url_ = this.config.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetUser(_response);
        });
    }
    processGetUser(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("User not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get user picture by id.
     * @param id The id of the user (GUID).
     * @return User found and image or fallback returned.
     */
    getUserPicture(id) {
        let url_ = this.config.baseUrl + "/api/users/{id}/picture";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetUserPicture(_response);
        });
    }
    processGetUserPicture(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("User not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UIApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get ui settings.
     * @return UI settings returned.
     */
    getSettings() {
        let url_ = this.config.baseUrl + "/api/ui/settings";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetSettings(_response);
        });
    }
    processGetSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UISettingsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get ui settings for a specific app.
     * @param app The name of the app.
     * @return UI settings returned.
     */
    getAppSettings(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/ui/settings";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAppSettings(_response);
        });
    }
    processGetAppSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get my ui settings.
     * @param app The name of the app.
     * @return UI settings returned.
     */
    getUserSettings(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/ui/settings/me";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetUserSettings(_response);
        });
    }
    processGetUserSettings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Set ui settings.
     * @param app The name of the app.
     * @param key The name of the setting.
     * @param request The request with the value to update.
     * @return UI setting set.
     */
    putSetting(app, key, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/ui/settings/{key}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/octet-stream"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutSetting(_response);
        });
    }
    processPutSetting(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove ui settings.
     * @param app The name of the app.
     * @param key The name of the setting.
     * @return UI setting removed.
     */
    deleteSetting(app, key) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/ui/settings/{key}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteSetting(_response);
        });
    }
    processDeleteSetting(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Set my ui settings.
     * @param app The name of the app.
     * @param key The name of the setting.
     * @param request The request with the value to update.
     * @return UI setting set.
     */
    putUserSetting(app, key, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/ui/settings/me/{key}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/octet-stream"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutUserSetting(_response);
        });
    }
    processPutUserSetting(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove my ui settings.
     * @param app The name of the app.
     * @param key The name of the setting.
     * @return UI setting removed.
     */
    deleteUserSetting(app, key) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/ui/settings/me/{key}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteUserSetting(_response);
        });
    }
    processDeleteUserSetting(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class TranslationsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Translate a text.
     * @param app The name of the app.
     * @param request The translation request.
     * @return Text translated.
     */
    getLanguages(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/translations";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetLanguages(_response);
        });
    }
    processGetLanguages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TranslationDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UsagesApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get api calls as log file.
     * @param app The name of the app.
     * @return Usage tracking results returned.
     */
    getLog(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/usages/log";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetLog(_response);
        });
    }
    processGetLog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LogDownloadDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get api calls in date range.
     * @param app The name of the app.
     * @param fromDate The from date.
     * @param toDate The to date.
     * @return API call returned.
     */
    getUsages(app, fromDate, toDate) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/usages/calls/{fromDate}/{toDate}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toJSON() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetUsages(_response);
        });
    }
    processGetUsages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CallsUsageDtoDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Range between from date and to date is not valid or has more than 100 days.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get total asset size.
     * @param app The name of the app.
     * @return Storage usage returned.
     */
    getCurrentStorageSize(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/usages/storage/today";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetCurrentStorageSize(_response);
        });
    }
    processGetCurrentStorageSize(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CurrentStorageDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get asset usage by date.
     * @param app The name of the app.
     * @param fromDate The from date.
     * @param toDate The to date.
     * @return Storage usage returned.
     */
    getStorageSizes(app, fromDate, toDate) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/usages/storage/{fromDate}/{toDate}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined.");
        url_ = url_.replace("{fromDate}", encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "null"));
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined.");
        url_ = url_.replace("{toDate}", encodeURIComponent(toDate ? "" + toDate.toJSON() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetStorageSizes(_response);
        });
    }
    processGetStorageSizes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(StorageUsagePerDateDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Range between from date and to date is not valid or has more than 100 days.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SearchApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get search results.
     * @param app The name of the app.
     * @param query (optional) The search query.
     * @return Search results returned.
     */
    getSchemas(app, query) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/search?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetSchemas(_response);
        });
    }
    processGetSchemas(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SearchResultDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Content and Assets.
     * @param app The name of the app to get the contents for.
     * @param search (optional) Optional OData full text search.
     * @param top (optional) Optional number of items to take.
     * @param skip (optional) Optional number of items to skip.
     * @param orderby (optional) Optional OData order definition.
     * @param filter (optional) Optional OData filter definition.
     * @param q (optional)
     * @param includePermissions (optional) Whether to include PermissionSet permissions with items.
     * @return Assets and Content returned. If only searching on an asset or content specific value,
     */
    getAllContentAndAssets(app, search, top, skip, orderby, filter, q, includePermissions) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/all?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (includePermissions === null)
            throw new Error("The parameter 'includePermissions' cannot be null.");
        else if (includePermissions !== undefined)
            url_ += "includePermissions=" + encodeURIComponent("" + includePermissions) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAllContentAndAssets(_response);
        });
    }
    processGetAllContentAndAssets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllAssetsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ContentTypeFieldsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Add a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The field object that needs to be added to the content type.
     * @return Content Type field created.
     */
    postField(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostField(_response);
        });
    }
    processPostField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = ContentTypeDetailsDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field properties not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ErrorDto.fromJS(resultData409);
                return throwException("Content Type field name already in use.", status, _responseText, _headers, result409);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param request The field object that needs to be added to the content type.
     * @return Content Type field created.
     */
    postNestedField(app, name, parentId, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostNestedField(_response);
        });
    }
    processPostNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = ContentTypeDetailsDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field properties not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ErrorDto.fromJS(resultData409);
                return throwException("Content Type field name already in use.", status, _responseText, _headers, result409);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Configure UI fields.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The request that contains the field names.
     * @return Content Type UI fields defined.
     */
    putContentTypeUIFields(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/ui";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutContentTypeUIFields(_response);
        });
    }
    processPutContentTypeUIFields(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field contains invalid field names.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Reorders the fields.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The request that contains the field ids.
     * @return Content Type fields reordered.
     */
    putContentTypeFieldOrdering(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/ordering";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutContentTypeFieldOrdering(_response);
        });
    }
    processPutContentTypeFieldOrdering(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field ids do not cover the fields of the content type.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Reorders the nested fields.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param request The request that contains the field ids.
     * @return Content Type fields reordered.
     */
    putNestedFieldOrdering(app, name, parentId, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/ordering";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutNestedFieldOrdering(_response);
        });
    }
    processPutNestedFieldOrdering(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field ids do not cover the fields of the content type.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to update.
     * @param request The field object that needs to be added to the content type.
     * @return Content Type field updated.
     */
    putField(app, name, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutField(_response);
        });
    }
    processPutField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field properties not valid or field is locked.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to disable.
     * @return Content Type field deleted.
     */
    deleteField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteField(_response);
        });
    }
    processDeleteField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Field is locked.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to update.
     * @param request The field object that needs to be added to the content type.
     * @return Content Type field updated.
     */
    putNestedField(app, name, parentId, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutNestedField(_response);
        });
    }
    processPutNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field properties not valid or field is locked.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to disable.
     * @return Content Type field deleted.
     */
    deleteNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteNestedField(_response);
        });
    }
    processDeleteNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Field is locked.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Lock a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to lock.
     * @return Content Type field locked.
     */
    lockField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}/lock";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processLockField(_response);
        });
    }
    processLockField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Lock a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to lock.
     * @return Content Type field locked.
     */
    lockNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}/lock";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processLockNestedField(_response);
        });
    }
    processLockNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Field, content type, or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Hide a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to hide.
     * @return Content Type field hidden.
     */
    hideField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}/hide";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processHideField(_response);
        });
    }
    processHideField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Hide a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to hide.
     * @return Content Type field hidden.
     */
    hideNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}/hide";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processHideNestedField(_response);
        });
    }
    processHideNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Field, content type, or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Show a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to show.
     * @return Content Type field shown.
     */
    showField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}/show";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processShowField(_response);
        });
    }
    processShowField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Show a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to show.
     * @return Content Type field shown.
     */
    showNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}/show";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processShowNestedField(_response);
        });
    }
    processShowNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Enable a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to enable.
     * @return Content Type field enabled.
     */
    enableField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}/enable";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processEnableField(_response);
        });
    }
    processEnableField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Enable a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to enable.
     * @return Content Type field enabled.
     */
    enableNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}/enable";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processEnableNestedField(_response);
        });
    }
    processEnableNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Disable a content type field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to disable.
     * @return Content Type field disabled.
     */
    disableField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}/disable";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDisableField(_response);
        });
    }
    processDisableField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Disable a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to disable.
     * @return Content Type field disabled.
     */
    disableNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}/disable";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDisableNestedField(_response);
        });
    }
    processDisableNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Unlock a Content Type field.
     * @param app The name of the app.
     * @param name The name of the Content Type.
     * @param id The id of the field to unlock.
     * @return Content Type field unlocked.
     */
    unlockField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}/unlock";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processUnlockField(_response);
        });
    }
    processUnlockField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field already unlocked.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field, or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Unlock a Nested Content Type field.
     * @param app The name of the app.
     * @param name The name of the Content Type.
     * @param parentId The parent field id.
     * @param id The id of the field to unlock.
     * @return Content Type field unlocked.
     */
    unlockNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}/unlock";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processUnlockNestedField(_response);
        });
    }
    processUnlockNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type field already unlocked.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type, field, or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Encrypt a field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the field to encrypt.
     * @return Content Type field encrypted.
     */
    encryptField(app, name, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{id}/encrypt";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processEncryptField(_response);
        });
    }
    processEncryptField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Field, content type, or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Encrypt a nested field.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param parentId The parent field id.
     * @param id The id of the field to encrypt.
     * @return Content Type field encrypted.
     */
    encryptNestedField(app, name, parentId, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/fields/{parentId}/nested/{id}/encrypt";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processEncryptNestedField(_response);
        });
    }
    processEncryptNestedField(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Field, content type, or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ContentTypesApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get content types.
     * @param app The name of the app.
     * @param includeDetails (optional) True: include content-type details (i.e. field details).
     * @return Content Types returned.
     */
    getContentTypes(app, includeDetails) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (includeDetails === null)
            throw new Error("The parameter 'includeDetails' cannot be null.");
        else if (includeDetails !== undefined)
            url_ += "includeDetails=" + encodeURIComponent("" + includeDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContentTypes(_response);
        });
    }
    processGetContentTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new content type.
     * @param app The name of the app.
     * @param request The content type object that needs to be added to the app.
     * @return Content Type created.
     */
    postContentType(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostContentType(_response);
        });
    }
    processPostContentType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = ContentTypeDetailsDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type name or properties are not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ErrorDto.fromJS(resultData409);
                return throwException("Content Type name already in use.", status, _responseText, _headers, result409);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a content type by name.
     * @param app The name of the app.
     * @param name The name of the content type to retrieve.
     * @return Content Type found.
     */
    getContentType(app, name) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContentType(_response);
        });
    }
    processGetContentType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a content type.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The content type object that needs to updated.
     * @return Content Type updated.
     */
    putContentType(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutContentType(_response);
        });
    }
    processPutContentType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type properties are not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a content type.
     * @param app The name of the app.
     * @param name The name of the content type to delete.
     * @return Content Type deleted.
     */
    deleteContentType(app, name) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteContentType(_response);
        });
    }
    processDeleteContentType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Synchronize a content type.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The content type object that needs to updated.
     * @return Content Type updated.
     */
    putContentTypeSync(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/sync";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutContentTypeSync(_response);
        });
    }
    processPutContentTypeSync(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type properties are not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a content type section.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The content type object that needs to updated.
     * @return Content Type updated.
     */
    putCategory(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/section";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutCategory(_response);
        });
    }
    processPutCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update the preview urls.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The preview urls for the content type.
     * @return Content Type updated.
     */
    putPreviewUrls(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/preview-urls";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutPreviewUrls(_response);
        });
    }
    processPutPreviewUrls(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update the scripts.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The content type scripts object that needs to updated.
     * @return Content Type updated.
     */
    putScripts(app, name, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/scripts";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutScripts(_response);
        });
    }
    processPutScripts(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content Type properties are not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Publish a content type.
     * @param app The name of the app.
     * @param name The name of the content type to publish.
     * @return Content Type has been published.
     */
    publishContentType(app, name) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/publish";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPublishContentType(_response);
        });
    }
    processPublishContentType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Unpublish a content type.
     * @param app The name of the app.
     * @param name The name of the content type to unpublish.
     * @return Content Type has been unpublished.
     */
    unpublishContentType(app, name) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/content-types/{name}/unpublish";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processUnpublishContentType(_response);
        });
    }
    processUnpublishContentType(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentTypeDetailsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class PermissionSetApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app permission sets.
     * @param app The name of the app.
     * @param search (optional) Optional OData full text search.
     * @param top (optional) Optional number of permissionSet to take.
     * @param skip (optional) Optional number of permissionSet to skip.
     * @param orderby (optional) Optional OData order definition.
     * @param filter (optional) Optional OData filter definition.
     * @return App permission sets returned.
     */
    getPermissionSets(app, search, top, skip, orderby, filter) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/permissionset?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetPermissionSets(_response);
        });
    }
    processGetPermissionSets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PermissionSetsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add permission set to app.
     * @param app The name of the app.
     * @param request Permission set object that needs to be added to the app.
     * @return Permission set added to app.
     */
    postPermissionSet(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/permissionset";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostPermissionSet(_response);
        });
    }
    processPostPermissionSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = PermissionSetDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get single permission set.
     * @param app The name of the app.
     * @param id Permission set Id to retrieve.
     * @return App permission sets returned.
     */
    getPermissionSet(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/permissionset/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetPermissionSet(_response);
        });
    }
    processGetPermissionSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PermissionSetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update permission set.
     * @param app App Name (routing only).
     * @param id PermissionSet Id to Update.
     * @param request Update Request dto.
     * @return No Content
     */
    putPermissionSet(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/permissionset/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutPermissionSet(_response);
        });
    }
    processPutPermissionSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App/PermissionSet Not Found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove permission set from app.
     * @param app The name of the app.
     * @param id The id of the permission set.
     * @return Permission set removed from app.
     */
    deletePermissionSet(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/permissionset/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeletePermissionSet(_response);
        });
    }
    processDeletePermissionSet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Permission set is not found on app.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update permission set group permission.
     * @param app App Name (routing only).
     * @param id Permission set Id to Update.
     * @param request Update Request dto.
     * @return No Content
     */
    putPermissionSetGroup(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/permissionset/{id}/group";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutPermissionSetGroup(_response);
        });
    }
    processPutPermissionSetGroup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App/Permission set/Group Not Found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update permission set client permission.
     * @param app App Name (routing only).
     * @param id Permission set Id to Update.
     * @param request Update Request dto.
     * @return No Content
     */
    putPermissionSetClient(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/permissionset/{id}/client";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutPermissionSetClient(_response);
        });
    }
    processPutPermissionSetClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("App/Permission set/Client Not Found.", status, _responseText, _headers, result404);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class LanguagesApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get supported languages.
     * @return Supported language codes returned.
     */
    getLanguages() {
        let url_ = this.config.baseUrl + "/api/languages";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetLanguages(_response);
        });
    }
    processGetLanguages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(LanguageDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class HistoryApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get historical events.
     * @param app The name of the app.
     * @param channel (optional) The name of the channel.
     * @return Events returned.
     */
    getHistory(app, channel) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/history?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (channel !== undefined && channel !== null)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetHistory(_response);
        });
    }
    processGetHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(HistoryEventDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class ContentsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * GraphQL endpoint.
     * @param app The name of the app.
     * @param query The graphql query.
     * @return Contents retrieved or mutated.
     */
    getGraphQL(app, query) {
        let url_ = this.config.baseUrl + "/api/content/{app}/graphql";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostGraphQL(_response);
        });
    }
    processPostGraphQL(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * GraphQL endpoint.
     * @param app The name of the app.
     * @param query The graphql query.
     * @return Contents retrieved or mutated.
     */
    getGraphQL2(app, query) {
        let url_ = this.config.baseUrl + "/api/content/{app}/graphql";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostGraphQL2(_response);
        });
    }
    processPostGraphQL2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * GraphQL endpoint (Batch).
     * @param app The name of the app.
     * @param batch The graphql queries.
     * @return Contents retrieved or mutated.
     */
    getGraphQLBatch(app, batch) {
        let url_ = this.config.baseUrl + "/api/content/{app}/graphql/batch";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(batch);
        let options_ = {
            body: content_,
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostGraphQLBatch(_response);
        });
    }
    processPostGraphQLBatch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * GraphQL endpoint (Batch).
     * @param app The name of the app.
     * @param batch The graphql queries.
     * @return Contents retrieved or mutated.
     */
    getGraphQLBatch2(app, batch) {
        let url_ = this.config.baseUrl + "/api/content/{app}/graphql/batch";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(batch);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostGraphQLBatch2(_response);
        });
    }
    processPostGraphQLBatch2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Queries contents.
     * @param app The name of the app.
     * @param ids (optional) The optional ids of the content to fetch.
     * @return Contents retrieved.
     */
    getAllContents(app, ids) {
        let url_ = this.config.baseUrl + "/api/content/{app}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (ids !== undefined && ids !== null)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAllContents(_response);
        });
    }
    processGetAllContents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Queries contents.
     * @param app The name of the app.
     * @param query The required query object.
     * @return Contents retrieved.
     */
    getAllContentsPost(app, query) {
        let url_ = this.config.baseUrl + "/api/content/{app}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAllContentsPost(_response);
        });
    }
    processGetAllContentsPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Queries contents.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param search (optional) Optional OData full text search.
     * @param top (optional) Optional number of content to take.
     * @param skip (optional) Optional number of content to skip.
     * @param orderby (optional) Optional OData order definition.
     * @param filter (optional) Optional OData filter definition.
     * @param ids (optional) The optional ids of the content to fetch.
     * @param q (optional) The optional json query.
     * @return Contents retrieved.
     */
    getContents(app, name, search, top, skip, orderby, filter, ids, q) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (ids !== undefined && ids !== null)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContents(_response);
        });
    }
    processGetContents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The full data for the content item.
     * @param publish (optional) True to automatically publish the content.
     * @return Content created.
     */
    postContent(app, name, request, publish) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (publish === null)
            throw new Error("The parameter 'publish' cannot be null.");
        else if (publish !== undefined)
            url_ += "publish=" + encodeURIComponent("" + publish) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostContent(_response);
        });
    }
    processPostContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = ContentDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content data is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Queries contents.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param query The required query object.
     * @return Contents retrieved.
     */
    getContentsPost(app, name, query) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/query";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContentsPost(_response);
        });
    }
    processGetContentsPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content Type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content to fetch.
     * @return Content found.
     */
    getContent(app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContent(_response);
        });
    }
    processGetContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content to fetch.
     * @return Content found.
     */
    getContentHead(app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "HEAD",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContent2(_response);
        });
    }
    processGetContent2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item to update.
     * @param request The full data for the content item.
     * @return Content updated.
     */
    putContent(app, name, id, request) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutContent(_response);
        });
    }
    processPutContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content references, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content data is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Patchs a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item to patch.
     * @param request The patch for the content item.
     * @return Content patched.
     */
    patchContent(app, name, id, request) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPatchContent(_response);
        });
    }
    processPatchContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content patch is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item to delete.
     * @return Content deleted.
     */
    deleteContent(app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteContent(_response);
        });
    }
    processDeleteContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a content by version.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content to fetch.
     * @param version The version fo the content to fetch.
     * @return Content found.
     */
    getContentVersion(app, name, id, version) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/{version}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContentVersion(_response);
        });
    }
    processGetContentVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content data is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Bulk insert/update content items.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param request The bulk update request.
     * @return Contents created.
     */
    bulkContents(app, name, request) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/bulk";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processBulkContents(_response);
        });
    }
    processBulkContents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(BulkResultDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content references, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Content data is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Change status for a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item to publish.
     * @param request The status request.
     * @return Content status updated.
     */
    putContentStatus(app, name, id, request) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/status";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutContentStatus(_response);
        });
    }
    processPutContentStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Request is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new version.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item to discard changes.
     * @return Content draft created.
     */
    createDraft(app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/draft";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processCreateDraft(_response);
        });
    }
    processCreateDraft(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Discard changes.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item to discard changes.
     * @return Content draft version deleted.
     */
    deleteVersion(app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/draft";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteVersion(_response);
        });
    }
    processDeleteVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Generate Tags from Content.
     * @param content Text to generate tags.
     * @return Tags Generated.
     */
    generateTagsForContent(content, app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/tags";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(content);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGenerateTagsForContent(_response);
        });
    }
    processGenerateTagsForContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the NotificationDetails of a content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item to update.
     * @param notificationDetails The notification details of the content item.
     * @return Content updated.
     */
    updateNotification(app, name, id, notificationDetails) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/updatenotification";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(notificationDetails);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processUpdateNotification(_response);
        });
    }
    processUpdateNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Clear Content Schedule.
     * @param app The name of the app.
     * @param name The name of the Content Type.
     * @param id The id of the content item to clear schedule.
     * @return Schedule has been cleared.
     */
    clearSchedule(app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/clearschedule";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processClearSchedule(_response);
        });
    }
    processClearSchedule(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, Content Type, or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets the user permissions for the content type.
     * @param app The name of the app.
     * @param name The name of the Content Type.
     * @param permissionSetId (optional) The id of the permission set.
     * @return Permissions retrieved.
     */
    getPermissions(app, name, permissionSetId) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/permissions?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (permissionSetId === null)
            throw new Error("The parameter 'permissionSetId' cannot be null.");
        else if (permissionSetId !== undefined)
            url_ += "permissionSetId=" + encodeURIComponent("" + permissionSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetPermissions(_response);
        });
    }
    processGetPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key] ? ResourceLink.fromJS(resultData200[key]) : new ResourceLink();
                    }
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content type or permission set not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Decrypts all encrypted fields of the content item.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item.
     * @return The content item with all fields decrypted.
     */
    decryptContent(app, name, id) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/decrypt";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDecryptContent(_response);
        });
    }
    processDecryptContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Change status for a content item.
    Obsolete - Update to use the /status endpoint
     * @param app The name of the app.
     * @param name The name of the content type.
     * @param id The id of the content item.
     * @param status The status to update content item to.
     * @param dueTime (optional)
     * @return Content status updated.
     * @deprecated
     */
    putContentStatusString(app, name, id, status, notificationDetails, dueTime) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/{id}/{status}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (dueTime !== undefined && dueTime !== null)
            url_ += "dueTime=" + encodeURIComponent("" + dueTime) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(notificationDetails);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutContentStatusString(_response);
        });
    }
    processPutContentStatusString(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContentDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Content, content type or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Request is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get content tags.
     * @param app The name of the app.
     * @param name The name of the content type.
     * @return Tags returned.
     */
    getTags(app, name) {
        let url_ = this.config.baseUrl + "/api/content/{app}/{name}/tags";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetTags(_response);
        });
    }
    processGetTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class CategoriesApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app categories.
     * @param app The name of the app.
     * @param search (optional) Optional OData full text search.
     * @param top (optional) Optional number of category to take.
     * @param skip (optional) Optional number of category to skip.
     * @param orderby (optional) Optional OData order definition.
     * @param filter (optional) Optional OData filter definition.
     * @return App categories returned.
     */
    getCategories(app, search, top, skip, orderby, filter) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/categories?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetCategories(_response);
        });
    }
    processGetCategories(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CategoriesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App or Category not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add category to app.
     * @param app The name of the app.
     * @param request Category object that needs to be added to the app.
     * @return Category added to app.
     */
    postCategory(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/categories";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostCategory(_response);
        });
    }
    processPostCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = CategoryDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App or Category not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get single category.
     * @param app The name of the app.
     * @param id Cateogry Id to retrieve.
     * @return App categories returned.
     */
    getCategory(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/categories/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetCategory(_response);
        });
    }
    processGetCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CategoryDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App or Category not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update category.
     * @param app App Name (routing only).
     * @param id Category Id to Update.
     * @param request Update Request dto.
     * @return No Content
     */
    putCategory(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/categories/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutCategory(_response);
        });
    }
    processPutCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App or Category not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove category from app.
     * @param app The name of the app.
     * @param id The id of the category.
     * @return Category removed from app.
     */
    deleteCategory(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/categories/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteCategory(_response);
        });
    }
    processDeleteCategory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Category is not found on app.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App or Category not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BackupContentApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get the backup content.
     * @param app The name of the app.
     * @param id The id of the asset.
     * @return Backup found and content returned.
     */
    getBackupContent(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/backups/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetBackupContent(_response);
        });
    }
    processGetBackupContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Backup or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class BackupsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Delete a backup.
     * @param app The name of the app.
     * @param id The id of the backup to delete.
     * @return Backup started.
     */
    deleteBackup(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/backups/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteBackup(_response);
        });
    }
    processDeleteBackup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Backup or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get all backup jobs.
     * @param app The name of the app.
     * @return Backups returned.
     */
    getBackups(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/backups";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetBackups(_response);
        });
    }
    processGetBackups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BackupJobsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Start a new backup.
     * @param app The name of the app.
     * @return Backup started.
     */
    postBackup(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/backups";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostBackup(_response);
        });
    }
    processPostBackup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class RestoreApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get current restore status.
     * @return Status returned.
     */
    getRestoreJob() {
        let url_ = this.config.baseUrl + "/api/apps/restore";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetRestoreJob(_response);
        });
    }
    processGetRestoreJob(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RestoreJobDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Restore a backup.
     * @param request The backup to restore.
     * @return Restore operation started.
     */
    postRestoreJob(request) {
        let url_ = this.config.baseUrl + "/api/apps/restore";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostRestoreJob(_response);
        });
    }
    processPostRestoreJob(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AssetContentApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get the asset content.
     * @param app The name of the app.
     * @param idOrSlug The id or slug of the asset.
     * @param more Optional suffix that can be used to seo-optimize the link to the image Has not effect.
     * @param version (optional) The optional version of the asset.
     * @param cache (optional) The cache duration in seconds.
     * @param download (optional) Set it to 0 to prevent download.
     * @param width (optional) The target width of the asset, if it is an image.
     * @param height (optional) The target height of the asset, if it is an image.
     * @param quality (optional) Optional image quality, it is is an jpeg image.
     * @param mode (optional) The resize mode when the width and height is defined.
     * @param focusX (optional) Override the y focus point.
     * @param focusY (optional) Override the x focus point.
     * @param nofocus (optional) True to ignore the asset focus point if any.
     * @param keepformat (optional) True to not use JPEG encoding when quality is set and the image is not a JPEG. Default: false.
     * @param force (optional) True to force a new resize even if it already stored.
     * @param scope (optional) The search scope. Either 'all' (any status) or 'published'&gt;.
     * @return Asset found and content or (resized) image returned.
     */
    getAssetContentBySlug(app, idOrSlug, more, version, cache, download, width, height, quality, mode, focusX, focusY, nofocus, keepformat, force, scope) {
        let url_ = this.config.baseUrl + "/api/assets/{app}/{idOrSlug}/{more}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (idOrSlug === undefined || idOrSlug === null)
            throw new Error("The parameter 'idOrSlug' must be defined.");
        url_ = url_.replace("{idOrSlug}", encodeURIComponent("" + idOrSlug));
        if (more === undefined || more === null)
            throw new Error("The parameter 'more' must be defined.");
        url_ = url_.replace("{more}", encodeURIComponent("" + more));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (cache === null)
            throw new Error("The parameter 'cache' cannot be null.");
        else if (cache !== undefined)
            url_ += "cache=" + encodeURIComponent("" + cache) + "&";
        if (download === null)
            throw new Error("The parameter 'download' cannot be null.");
        else if (download !== undefined)
            url_ += "download=" + encodeURIComponent("" + download) + "&";
        if (width !== undefined && width !== null)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (quality !== undefined && quality !== null)
            url_ += "quality=" + encodeURIComponent("" + quality) + "&";
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (focusX !== undefined && focusX !== null)
            url_ += "focusX=" + encodeURIComponent("" + focusX) + "&";
        if (focusY !== undefined && focusY !== null)
            url_ += "focusY=" + encodeURIComponent("" + focusY) + "&";
        if (nofocus === null)
            throw new Error("The parameter 'nofocus' cannot be null.");
        else if (nofocus !== undefined)
            url_ += "nofocus=" + encodeURIComponent("" + nofocus) + "&";
        if (keepformat === null)
            throw new Error("The parameter 'keepformat' cannot be null.");
        else if (keepformat !== undefined)
            url_ += "keepformat=" + encodeURIComponent("" + keepformat) + "&";
        if (force === null)
            throw new Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        if (scope !== undefined && scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAssetContentBySlug(_response);
        });
    }
    processGetAssetContentBySlug(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the asset content.
     * @param id The id of the asset.
     * @param version (optional) The optional version of the asset.
     * @param cache (optional) The cache duration in seconds.
     * @param download (optional) Set it to 0 to prevent download.
     * @param width (optional) The target width of the asset, if it is an image.
     * @param height (optional) The target height of the asset, if it is an image.
     * @param quality (optional) Optional image quality, it is is an jpeg image.
     * @param mode (optional) The resize mode when the width and height is defined.
     * @param focusX (optional) Override the y focus point.
     * @param focusY (optional) Override the x focus point.
     * @param nofocus (optional) True to ignore the asset focus point if any.
     * @param keepformat (optional) True to not use JPEG encoding when quality is set and the image is not a JPEG. Default: false.
     * @param force (optional) True to force a new resize even if it already stored.
     * @param scope (optional) The search scope. Either 'all' (any status) or 'published'&gt;.
     * @return Asset found and content or (resized) image returned.
     */
    getAssetContent(id, version, cache, download, width, height, quality, mode, focusX, focusY, nofocus, keepformat, force, scope) {
        let url_ = this.config.baseUrl + "/api/assets/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (cache === null)
            throw new Error("The parameter 'cache' cannot be null.");
        else if (cache !== undefined)
            url_ += "cache=" + encodeURIComponent("" + cache) + "&";
        if (download === null)
            throw new Error("The parameter 'download' cannot be null.");
        else if (download !== undefined)
            url_ += "download=" + encodeURIComponent("" + download) + "&";
        if (width !== undefined && width !== null)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (quality !== undefined && quality !== null)
            url_ += "quality=" + encodeURIComponent("" + quality) + "&";
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (focusX !== undefined && focusX !== null)
            url_ += "focusX=" + encodeURIComponent("" + focusX) + "&";
        if (focusY !== undefined && focusY !== null)
            url_ += "focusY=" + encodeURIComponent("" + focusY) + "&";
        if (nofocus === null)
            throw new Error("The parameter 'nofocus' cannot be null.");
        else if (nofocus !== undefined)
            url_ += "nofocus=" + encodeURIComponent("" + nofocus) + "&";
        if (keepformat === null)
            throw new Error("The parameter 'keepformat' cannot be null.");
        else if (keepformat !== undefined)
            url_ += "keepformat=" + encodeURIComponent("" + keepformat) + "&";
        if (force === null)
            throw new Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        if (scope !== undefined && scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAssetContent(_response);
        });
    }
    processGetAssetContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AssetsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get assets tags.
     * @param app The name of the app.
     * @return Assets returned.
     */
    getTags(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/tags";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetTags(_response);
        });
    }
    processGetTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get assets.
     * @param app The name of the app.
     * @param search (optional) Optional OData full text search.
     * @param top (optional) Optional number of assets to take.
     * @param skip (optional) Optional number of assets to skip.
     * @param orderby (optional) Optional OData order definition.
     * @param filter (optional) Optional OData filter definition.
     * @param parentId (optional) The optional parent folder id.
     * @param ids (optional) The optional asset ids.
     * @param q (optional) The optional json query.
     * @return Assets returned.
     */
    getAssets(app, search, top, skip, orderby, filter, parentId, ids, q) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "$search=" + encodeURIComponent("" + search) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "$top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "$skip=" + encodeURIComponent("" + skip) + "&";
        if (orderby === null)
            throw new Error("The parameter 'orderby' cannot be null.");
        else if (orderby !== undefined)
            url_ += "$orderby=" + encodeURIComponent("" + orderby) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "$filter=" + encodeURIComponent("" + filter) + "&";
        if (parentId !== undefined && parentId !== null)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (ids !== undefined && ids !== null)
            url_ += "ids=" + encodeURIComponent("" + ids) + "&";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAssets(_response);
        });
    }
    processGetAssets(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Upload a new asset.
     * @param file The file to upload.
     * @param app The name of the app.
     * @param parentId (optional) The optional parent folder id.
     * @param publish (optional) Whether or not to publish asset.
     * @param briefDescription (optional)
     * @param tags (optional)
     * @param categories (optional)
     * @param permissionSet (optional)
     * @param emailAddresses (optional)
     * @param notificationOption (optional)
     * @param daysInAdvance (optional)
     * @param subject (optional)
     * @param emailIntroduction (optional)
     * @param smsMessage (optional)
     * @param sendAt (optional)
     * @param eventType (optional)
     * @param metadata (optional)
     * @return Asset created.
     */
    postAsset(file, app, parentId, publish, briefDescription, tags, categories, permissionSet, emailAddresses, notificationOption, daysInAdvance, subject, emailIntroduction, smsMessage, sendAt, eventType, metadata) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (publish === null)
            throw new Error("The parameter 'publish' cannot be null.");
        else if (publish !== undefined)
            url_ += "publish=" + encodeURIComponent("" + publish) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (briefDescription !== null && briefDescription !== undefined)
            content_.append("briefDescription", briefDescription.toString());
        if (tags !== null && tags !== undefined)
            tags.forEach(item_ => content_.append("tags", item_.toString()));
        if (categories !== null && categories !== undefined)
            categories.forEach(item_ => content_.append("categories", item_.toString()));
        if (permissionSet !== null && permissionSet !== undefined)
            content_.append("permissionSet", permissionSet.toString());
        if (emailAddresses !== null && emailAddresses !== undefined)
            emailAddresses.forEach(item_ => content_.append("emailAddresses", item_.toString()));
        if (notificationOption !== null && notificationOption !== undefined)
            content_.append("NotificationOption", notificationOption.toString());
        if (daysInAdvance !== null && daysInAdvance !== undefined)
            content_.append("DaysInAdvance", daysInAdvance.toString());
        if (subject !== null && subject !== undefined)
            content_.append("Subject", subject.toString());
        if (emailIntroduction !== null && emailIntroduction !== undefined)
            content_.append("EmailIntroduction", emailIntroduction.toString());
        if (smsMessage !== null && smsMessage !== undefined)
            content_.append("SmsMessage", smsMessage.toString());
        if (sendAt !== null && sendAt !== undefined)
            content_.append("SendAt", sendAt.toJSON());
        if (eventType !== null && eventType !== undefined)
            content_.append("EventType", eventType.toString());
        if (metadata !== null && metadata !== undefined)
            content_.append("metadata", JSON.stringify(metadata));
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostAsset(_response);
        });
    }
    processPostAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = AssetDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Asset exceeds the maximum size.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get assets.
     * @param app The name of the app.
     * @param query The required query object.
     * @return Assets returned.
     */
    getAssetsPost(app, query) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/query";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(query);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAssetsPost(_response);
        });
    }
    processGetAssetsPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an asset by id.
     * @param app The name of the app.
     * @param id The id of the asset to retrieve.
     * @param version (optional)
     * @return Asset found.
     */
    getAsset(app, id, version) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAsset(_response);
        });
    }
    processGetAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the asset.
     * @param app The name of the app.
     * @param id The id of the asset.
     * @param request The asset object that needs to updated.
     * @return Asset updated.
     */
    putAsset(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutAsset(_response);
        });
    }
    processPutAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Asset name not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an asset.
     * @param app The name of the app.
     * @param id The id of the asset to delete.
     * @return Asset deleted.
     */
    deleteAsset(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteAsset(_response);
        });
    }
    processDeleteAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Replace asset content.
     * @param file The file to upload.
     * @param app The name of the app.
     * @param id The id of the asset.
     * @return Asset updated.
     */
    putAssetContent(file, app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}/content";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutAssetContent(_response);
        });
    }
    processPutAssetContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Asset exceeds the maximum size.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new version.
     * @param app The name of the app.
     * @param id The id of the asset to discard changes.
     * @return Asset version created.
     */
    createDraft(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}/draft";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processCreateDraft(_response);
        });
    }
    processCreateDraft(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Discard changes.
     * @param app The name of the app.
     * @param id The id of the asset to discard the version.
     * @return Asset version deleted.
     */
    deleteDraft(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}/draft";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteDraft(_response);
        });
    }
    processDeleteDraft(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update status.
     * @param app The name of the app.
     * @param id The id of the asset to update the status.
     * @param request The status change request.
     * @return Asset status updated.
     */
    putAssetStatus(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}/status";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutAssetStatus(_response);
        });
    }
    processPutAssetStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Analyze asset and retrieve tags and descriptions.
     * @param file The file to upload.
     * @param app The name of the app.
     * @return Suggestions retreived.
     */
    suggestions(file, app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/suggestions";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processSuggestions(_response);
        });
    }
    processSuggestions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetSuggestionResults.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Asset exceeds the maximum size.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets the user permissions for the asset.
     * @param app The name of the app.
     * @param permissionSetId (optional) The id of the permission set.
     * @return Permissions retrieved.
     */
    getPermissions(app, permissionSetId) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/permissions?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (permissionSetId === null)
            throw new Error("The parameter 'permissionSetId' cannot be null.");
        else if (permissionSetId !== undefined)
            url_ += "permissionSetId=" + encodeURIComponent("" + permissionSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetPermissions(_response);
        });
    }
    processGetPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (let key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key] ? ResourceLink.fromJS(resultData200[key]) : new ResourceLink();
                    }
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Permission set not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Clear Asset Schedule.
     * @param app The name of the app.
     * @param id The id of the asset to clear schedule.
     * @return Schedule has been cleared.
     */
    clearSchedule(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}/clearschedule";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processClearSchedule(_response);
        });
    }
    processClearSchedule(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the NotificationDetails of an asset.
     * @param app The name of the app.
     * @param id The id of the asset to update.
     * @param notificationDetails The notification details of the asset.
     * @return Asset updated.
     */
    updateNotification(app, id, notificationDetails) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}/updatenotification";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(notificationDetails);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processUpdateNotification(_response);
        });
    }
    processUpdateNotification(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update asset status.
     * @param app The name of the app.
     * @param id The id of the asset to update the status.
     * @param status Status to move asset to.
     * @param request The status change request.
     * @param dueTime (optional)
     * @return Asset status updated.
     * @deprecated
     */
    putAssetStringStatus(app, id, status, request, dueTime) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/{id}/{status}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (dueTime !== undefined && dueTime !== null)
            url_ += "dueTime=" + encodeURIComponent("" + dueTime) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutAssetStringStatus(_response);
        });
    }
    processPutAssetStringStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AssetsEncryptedApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get an encrypted asset by id.
     * @param app The name of the app.
     * @param id The id of the asset to retrieve.
     * @param version (optional)
     * @return Asset found.
     * @deprecated
     */
    getAsset(app, id, version) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/encrypt/{id}?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAsset(_response);
        });
    }
    processGetAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AssetDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the encrypted asset metadata.
     * @param app The name of the app.
     * @param id The id of the asset.
     * @param request The asset object that needs to updated.
     * @return Asset updated.
     * @deprecated
     */
    putAsset(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/encrypt/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutAsset(_response);
        });
    }
    processPutAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Asset name not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates the encrypted asset metadata.
     * @param app The name of the app.
     * @param id The id of the asset.
     * @param request The asset object that needs to updated.
     * @return Asset updated.
     * @deprecated
     */
    patchAsset(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/encrypt/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PATCH",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutAsset2(_response);
        });
    }
    processPutAsset2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Asset name not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an encrypted asset.
     * @param app The name of the app.
     * @param id The id of the asset to delete.
     * @return Asset has been deleted.
     * @deprecated
     */
    deleteAsset(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/encrypt/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteAsset(_response);
        });
    }
    processDeleteAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Asset or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Upload a new encrypted asset.
     * @param file The file to upload.
     * @param app The name of the app.
     * @param parentId (optional) The optional parent folder id.
     * @param tags (optional)
     * @param categories (optional)
     * @param permissionSet (optional)
     * @param notificationOption (optional)
     * @param daysInAdvance (optional)
     * @param subject (optional)
     * @param emailIntroduction (optional)
     * @param smsMessage (optional)
     * @param sendAt (optional)
     * @param eventType (optional)
     * @param emailAddresses (optional)
     * @return Asset created.
     * @deprecated
     */
    postAsset(file, app, parentId, tags, categories, permissionSet, notificationOption, daysInAdvance, subject, emailIntroduction, smsMessage, sendAt, eventType, emailAddresses) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/encrypt?";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (tags !== null && tags !== undefined)
            tags.forEach(item_ => content_.append("tags", item_.toString()));
        if (categories !== null && categories !== undefined)
            categories.forEach(item_ => content_.append("categories", item_.toString()));
        if (permissionSet !== null && permissionSet !== undefined)
            content_.append("permissionSet", permissionSet.toString());
        if (notificationOption !== null && notificationOption !== undefined)
            content_.append("NotificationOption", notificationOption.toString());
        if (daysInAdvance !== null && daysInAdvance !== undefined)
            content_.append("DaysInAdvance", daysInAdvance.toString());
        if (subject !== null && subject !== undefined)
            content_.append("Subject", subject.toString());
        if (emailIntroduction !== null && emailIntroduction !== undefined)
            content_.append("EmailIntroduction", emailIntroduction.toString());
        if (smsMessage !== null && smsMessage !== undefined)
            content_.append("SmsMessage", smsMessage.toString());
        if (sendAt !== null && sendAt !== undefined)
            content_.append("SendAt", sendAt.toJSON());
        if (eventType !== null && eventType !== undefined)
            content_.append("EventType", eventType.toString());
        if (emailAddresses !== null && emailAddresses !== undefined)
            emailAddresses.forEach(item_ => content_.append("emailAddresses", item_.toString()));
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostAsset(_response);
        });
    }
    processPostAsset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = AssetDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Asset exceeds the maximum size.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Download an encrypted asset.
     * @param id The id of the asset to download.
     * @param app The name of the app.
     * @return Asset has been downloaded.
     * @deprecated
     */
    getAssetContent(id, app, more) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/assets/encrypt/{id}/{more}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (more === undefined || more === null)
            throw new Error("The parameter 'more' must be defined.");
        url_ = url_.replace("{more}", encodeURIComponent("" + more));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetAssetContent(_response);
        });
    }
    processGetAssetContent(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403 = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ErrorDto.fromJS(resultData403);
                return throwException("Asset or app not found.", status, _responseText, _headers, result403);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppClientsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app clients.
     * @param app The name of the app.
     * @return Client keys returned.
     */
    getClients(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/clients";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetClients(_response);
        });
    }
    processGetClients(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClientsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new app client.
     * @param app The name of the app.
     * @param request Client object that needs to be added to the app.
     * @return Client generated.
     */
    postClient(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/clients";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostClient(_response);
        });
    }
    processPostClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = ClientsDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Client request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates an app client.
     * @param app The name of the app.
     * @param id The id of the client that must be updated.
     * @param request Client object that needs to be updated.
     * @return Client updated.
     */
    putClient(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/clients/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutClient(_response);
        });
    }
    processPutClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClientsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Client request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Client or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Revoke an app client.
     * @param app The name of the app.
     * @param id The id of the client that must be deleted.
     * @return Client revoked.
     */
    deleteClient(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/clients/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteClient(_response);
        });
    }
    processDeleteClient(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ClientsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Client or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppContributorsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app contributors.
     * @param app The name of the app.
     * @return App contributors returned.
     */
    getContributors(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/contributors";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetContributors(_response);
        });
    }
    processGetContributors(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContributorsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Assign contributor to app.
     * @param app The name of the app.
     * @param request Contributor object that needs to be added to the app.
     * @return User assigned to app.
     */
    postContributor(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/contributors";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostContributor(_response);
        });
    }
    processPostContributor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = ContributorsDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("User is not found.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove contributor.
     * @param app The name of the app.
     * @param id The id of the contributor.
     * @return User removed from app.
     */
    deleteContributor(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/contributors/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteContributor(_response);
        });
    }
    processDeleteContributor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ContributorsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Contributor or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppLanguagesApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app languages.
     * @param app The name of the app.
     * @return Language configuration returned.
     */
    getLanguages(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/languages";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetLanguages(_response);
        });
    }
    processGetLanguages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppLanguagesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Attaches an app language.
     * @param app The name of the app.
     * @param request The language to add to the app.
     * @return Language created.
     */
    postLanguage(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/languages";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostLanguage(_response);
        });
    }
    processPostLanguage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = AppLanguagesDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Language request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates an app language.
     * @param app The name of the app.
     * @param language The language to update.
     * @param request The language object.
     * @return Language updated.
     */
    putLanguage(app, language, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/languages/{language}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutLanguage(_response);
        });
    }
    processPutLanguage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppLanguagesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Language request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Language or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Deletes an app language.
     * @param app The name of the app.
     * @param language The language to delete from the app.
     * @return Language deleted.
     */
    deleteLanguage(app, language) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/languages/{language}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteLanguage(_response);
        });
    }
    processDeleteLanguage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppLanguagesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Language is master language.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Language or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppPatternsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app patterns.
     * @param app The name of the app.
     * @return Patterns returned.
     */
    getPatterns(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/patterns";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetPatterns(_response);
        });
    }
    processGetPatterns(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PatternsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new app pattern.
     * @param app The name of the app.
     * @param request Pattern to be added to the app.
     * @return Pattern generated.
     */
    postPattern(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/patterns";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostPattern(_response);
        });
    }
    processPostPattern(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = PatternsDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Pattern request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update an app pattern.
     * @param app The name of the app.
     * @param id The id of the pattern to be updated.
     * @param request Pattern to be updated for the app.
     * @return Pattern updated.
     */
    putPattern(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/patterns/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutPattern(_response);
        });
    }
    processPutPattern(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PatternsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Pattern request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Pattern or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an app pattern.
     * @param app The name of the app.
     * @param id The id of the pattern to be deleted.
     * @return Pattern removed.
     */
    deletePattern(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/patterns/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeletePattern(_response);
        });
    }
    processDeletePattern(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PatternsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Pattern or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppRolesApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app roles.
     * @param app The name of the app.
     * @return App roles returned.
     */
    getRoles(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/roles";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetRoles(_response);
        });
    }
    processGetRoles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RolesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Add role to app.
     * @param app The name of the app.
     * @param request Role object that needs to be added to the app.
     * @return User assigned to app.
     */
    postRole(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/roles";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostRole(_response);
        });
    }
    processPostRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = RolesDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Role name already in use.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get app permissions.
     * @param app The name of the app.
     * @return App permissions returned.
     */
    getPermissions(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/roles/permissions";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetPermissions(_response);
        });
    }
    processGetPermissions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(item);
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update an app role.
     * @param app The name of the app.
     * @param roleName The name of the role to be updated.
     * @param request Role to be updated for the app.
     * @return Role updated.
     */
    putRole(app, roleName, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/roles/{roleName}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutRole(_response);
        });
    }
    processPutRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RolesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Role request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Role or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove role from app.
     * @param app The name of the app.
     * @param roleName The name of the role.
     * @return Role deleted.
     */
    deleteRole(app, roleName) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/roles/{roleName}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (roleName === undefined || roleName === null)
            throw new Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteRole(_response);
        });
    }
    processDeleteRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RolesDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Role is in use by contributor or client or default role.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Role or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get your apps.
     * @return Apps returned.
     */
    getApps() {
        let url_ = this.config.baseUrl + "/api/apps";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetApps(_response);
        });
    }
    processGetApps(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AppDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a new app.
     * @param request The app object that needs to be added to CivicPlus.
     * @return App created.
     */
    postApp(request) {
        let url_ = this.config.baseUrl + "/api/apps";
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostApp(_response);
        });
    }
    processPostApp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201 = null;
                let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = AppDto.fromJS(resultData201);
                return result201;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("App request not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 409) {
            return response.text().then((_responseText) => {
                let result409 = null;
                let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = ErrorDto.fromJS(resultData409);
                return throwException("App name is already in use.", status, _responseText, _headers, result409);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get an app by name.
     * @param app The name of the app.
     * @return Apps returned.
     */
    getApp(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetApp(_response);
        });
    }
    processGetApp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update the app.
     * @param app The name of the app to update.
     * @param request The values to update.
     * @return App updated.
     */
    updateApp(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processUpdateApp(_response);
        });
    }
    processUpdateApp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Archive the app.
     * @param app The name of the app to archive.
     * @return App archived.
     */
    deleteApp(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {};
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteApp(_response);
        });
    }
    processDeleteApp(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the app image.
     * @param app The name of the app to update.
     * @param file (optional)
     * @return App image uploaded.
     */
    uploadImage(app, file) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/image";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processUploadImage(_response);
        });
    }
    processUploadImage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the app image.
     * @param app The name of the app.
     * @return App image found and content or (resized) image returned.
     */
    getImage(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/image";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/octet-stream"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetImage(_response);
        });
    }
    processGetImage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Remove the app image.
     * @param app The name of the app to update.
     * @return App image removed.
     */
    deleteImage(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/image";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteImage(_response);
        });
    }
    processDeleteImage(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppWorkflowsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app workflow.
     * @param app The name of the app.
     * @return App workflows returned.
     */
    getWorkflows(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/workflows";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetWorkflows(_response);
        });
    }
    processGetWorkflows(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WorkflowsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Create a workflow.
     * @param app The name of the app.
     * @param request The new workflow.
     * @return Workflow updated.
     */
    postWorkflow(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/workflows";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "POST",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPostWorkflow(_response);
        });
    }
    processPostWorkflow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WorkflowsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Workflow request is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Workflow or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Update a workflow.
     * @param app The name of the app.
     * @param id The id of the workflow to update.
     * @param request The new workflow.
     * @return Workflow updated.
     */
    putWorkflow(app, id, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/workflows/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
            "Accept": "application/json"
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processPutWorkflow(_response);
        });
    }
    processPutWorkflow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WorkflowsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ErrorDto.fromJS(resultData400);
                return throwException("Workflow request is not valid.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Workflow or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a workflow.
     * @param app The name of the app.
     * @param id The id of the workflow to update.
     * @return Workflow deleted.
     */
    deleteWorkflow(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/workflows/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "DELETE",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processDeleteWorkflow(_response);
        });
    }
    processDeleteWorkflow(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WorkflowsDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("Workflow or app not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AppGroupsApi extends BaseClient {
    constructor(configuration) {
        super(configuration);
        this.jsonParseReviver = undefined;
    }
    /**
     * Get app groups.
     * @param app The name of the app.
     * @return App groups returned.
     */
    getGroups(app) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/groups";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetGroups(_response);
        });
    }
    processGetGroups(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AppGroupDto.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Assign a group to an app level role.
     * @param app The name of the app.
     * @param request Group and Role to assign.
     * @return Group assigned success.
     */
    assignRole(app, request) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/groups/assign";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Content-Type": "application/json",
        };
        const content_ = JSON.stringify(request);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processAssignRole(_response);
        });
    }
    processAssignRole(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App or group not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get group users.
     * @param app The name of the app.
     * @param id The group id.
     * @return App groups returned.
     */
    getGroupUsers(app, id) {
        let url_ = this.config.baseUrl + "/api/apps/{app}/groups/users/{id}";
        if (app === undefined || app === null)
            throw new Error("The parameter 'app' must be defined.");
        url_ = url_.replace("{app}", encodeURIComponent("" + app));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        let headers_ = {
            "Accept": "application/json"
        };
        let options_ = {
            method: "GET",
            headers: headers_
        };
        return this.fetch(url_, options_).then((_response) => {
            return this.processGetGroupUsers(_response);
        });
    }
    processGetGroupUsers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GroupMembership.fromJS(item));
                }
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                return throwException("App not found.", status, _responseText, _headers);
            });
        }
        else if (status === 500) {
            return response.text().then((_responseText) => {
                let result500 = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = ErrorDto.fromJS(resultData500);
                return throwException("Operation failed", status, _responseText, _headers, result500);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class UserProperty {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserProperty();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UserProperty();
        result.init(json);
        return result;
    }
}
export class AccessTokenDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.idToken = _data["idToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["idToken"] = this.idToken;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AccessTokenDto();
        result.init(json);
        return result;
    }
}
export class Resource {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this._links = {};
        }
    }
    init(_data) {
        if (_data) {
            if (_data["_links"]) {
                this._links = {};
                for (let key in _data["_links"]) {
                    if (_data["_links"].hasOwnProperty(key))
                        this._links[key] = _data["_links"][key] ? ResourceLink.fromJS(_data["_links"][key]) : new ResourceLink();
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Resource' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (this._links) {
            data["_links"] = {};
            for (let key in this._links) {
                if (this._links.hasOwnProperty(key))
                    data["_links"][key] = this._links[key] ? this._links[key].toJSON() : undefined;
            }
        }
        return data;
    }
    clone() {
        throw new Error("The abstract class 'Resource' cannot be instantiated.");
    }
}
export class UsersDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UsersDto();
        result.init(json);
        return result;
    }
}
export class UserDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.permissions = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.isLocked = _data["isLocked"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [];
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["isLocked"] = this.isLocked;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}
export class ResourceLink {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.href = _data["href"];
            this.method = _data["method"];
            this.metadata = _data["metadata"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLink();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["href"] = this.href;
        data["method"] = this.method;
        data["metadata"] = this.metadata;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ResourceLink();
        result.init(json);
        return result;
    }
}
export class CreateUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }
    init(_data) {
        if (_data) {
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.password = _data["password"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [];
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["password"] = this.password;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}
export class UpdateUserDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }
    init(_data) {
        if (_data) {
            this.email = _data["email"];
            this.displayName = _data["displayName"];
            this.password = _data["password"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [];
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["displayName"] = this.displayName;
        data["password"] = this.password;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}
export class TagDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.count = _data["count"];
            this.assetCount = _data["assetCount"];
            this.contentCount = _data["contentCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["count"] = this.count;
        data["assetCount"] = this.assetCount;
        data["contentCount"] = this.contentCount;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new TagDto();
        result.init(json);
        return result;
    }
}
export class UpdateTagDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.displayName = _data["displayName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTagDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateTagDto();
        result.init(json);
        return result;
    }
}
export class EventConsumersDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(EventConsumerDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EventConsumersDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new EventConsumersDto();
        result.init(json);
        return result;
    }
}
export class EventConsumerDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.isStopped = _data["isStopped"];
            this.isResetting = _data["isResetting"];
            this.name = _data["name"];
            this.error = _data["error"];
            this.position = _data["position"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EventConsumerDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isStopped"] = this.isStopped;
        data["isResetting"] = this.isResetting;
        data["name"] = this.name;
        data["error"] = this.error;
        data["position"] = this.position;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new EventConsumerDto();
        result.init(json);
        return result;
    }
}
export class ResourcesDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ResourcesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ResourcesDto();
        result.init(json);
        return result;
    }
}
export class UISettingsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.canCreateApps = _data["canCreateApps"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UISettingsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["canCreateApps"] = this.canCreateApps;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UISettingsDto();
        result.init(json);
        return result;
    }
}
export class UpdateSettingDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSettingDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateSettingDto();
        result.init(json);
        return result;
    }
}
export class TranslationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.result = _data["result"];
            this.text = _data["text"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["text"] = this.text;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new TranslationDto();
        result.init(json);
        return result;
    }
}
export var TranslationResult;
(function (TranslationResult) {
    TranslationResult["Translated"] = "Translated";
    TranslationResult["LanguageNotSupported"] = "LanguageNotSupported";
    TranslationResult["NotTranslated"] = "NotTranslated";
    TranslationResult["NotImplemented"] = "NotImplemented";
    TranslationResult["Failed"] = "Failed";
})(TranslationResult || (TranslationResult = {}));
export class TranslateDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.text = _data["text"];
            this.targetLanguage = _data["targetLanguage"];
            this.sourceLanguage = _data["sourceLanguage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["targetLanguage"] = this.targetLanguage;
        data["sourceLanguage"] = this.sourceLanguage;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new TranslateDto();
        result.init(json);
        return result;
    }
}
export class LogDownloadDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.downloadUrl = _data["downloadUrl"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LogDownloadDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["downloadUrl"] = this.downloadUrl;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new LogDownloadDto();
        result.init(json);
        return result;
    }
}
export class CallsUsageDtoDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = {};
        }
    }
    init(_data) {
        if (_data) {
            this.totalCalls = _data["totalCalls"];
            this.totalBytes = _data["totalBytes"];
            this.allowedCalls = _data["allowedCalls"];
            this.averageElapsedMs = _data["averageElapsedMs"];
            if (_data["details"]) {
                this.details = {};
                for (let key in _data["details"]) {
                    if (_data["details"].hasOwnProperty(key))
                        this.details[key] = _data["details"][key] ? _data["details"][key].map((i) => CallsUsagePerDateDto.fromJS(i)) : [];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CallsUsageDtoDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalCalls"] = this.totalCalls;
        data["totalBytes"] = this.totalBytes;
        data["allowedCalls"] = this.allowedCalls;
        data["averageElapsedMs"] = this.averageElapsedMs;
        if (this.details) {
            data["details"] = {};
            for (let key in this.details) {
                if (this.details.hasOwnProperty(key))
                    data["details"][key] = this.details[key];
            }
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CallsUsageDtoDto();
        result.init(json);
        return result;
    }
}
export class CallsUsagePerDateDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.totalCalls = _data["totalCalls"];
            this.totalBytes = _data["totalBytes"];
            this.averageElapsedMs = _data["averageElapsedMs"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CallsUsagePerDateDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["totalCalls"] = this.totalCalls;
        data["totalBytes"] = this.totalBytes;
        data["averageElapsedMs"] = this.averageElapsedMs;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CallsUsagePerDateDto();
        result.init(json);
        return result;
    }
}
export class CurrentStorageDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.size = _data["size"];
            this.maxAllowed = _data["maxAllowed"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentStorageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["size"] = this.size;
        data["maxAllowed"] = this.maxAllowed;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CurrentStorageDto();
        result.init(json);
        return result;
    }
}
export class StorageUsagePerDateDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined;
            this.totalCount = _data["totalCount"];
            this.totalSize = _data["totalSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUsagePerDateDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["totalCount"] = this.totalCount;
        data["totalSize"] = this.totalSize;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new StorageUsagePerDateDto();
        result.init(json);
        return result;
    }
}
export class SearchResultDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.label = _data["label"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["label"] = this.label;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new SearchResultDto();
        result.init(json);
        return result;
    }
}
export var SearchResultType;
(function (SearchResultType) {
    SearchResultType["Asset"] = "Asset";
    SearchResultType["Content"] = "Content";
    SearchResultType["Dashboard"] = "Dashboard";
    SearchResultType["Setting"] = "Setting";
    SearchResultType["Rule"] = "Rule";
    SearchResultType["Schema"] = "Schema";
})(SearchResultType || (SearchResultType = {}));
export class AllAssetsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(IBaseDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AllAssetsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AllAssetsDto();
        result.init(json);
        return result;
    }
}
export class IBaseDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined;
            this.scheduleJob = _data["scheduleJob"] ? ScheduleJobDto.fromJS(_data["scheduleJob"]) : undefined;
            this.permissionSet = _data["permissionSet"] ? PermissionSetDto.fromJS(_data["permissionSet"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IBaseDto' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["scheduleJob"] = this.scheduleJob ? this.scheduleJob.toJSON() : undefined;
        data["permissionSet"] = this.permissionSet ? this.permissionSet.toJSON() : undefined;
        return data;
    }
    clone() {
        throw new Error("The abstract class 'IBaseDto' cannot be instantiated.");
    }
}
export class ScheduleJobDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.dueTime = _data["dueTime"] ? new Date(_data["dueTime"].toString()) : undefined;
            this.color = _data["color"];
            this.scheduledBy = _data["scheduledBy"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleJobDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["dueTime"] = this.dueTime ? this.dueTime.toISOString() : undefined;
        data["color"] = this.color;
        data["scheduledBy"] = this.scheduledBy;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ScheduleJobDto();
        result.init(json);
        return result;
    }
}
export class PermissionSetDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.version = _data["version"];
            if (Array.isArray(_data["groupPermissions"])) {
                this.groupPermissions = [];
                for (let item of _data["groupPermissions"])
                    this.groupPermissions.push(GroupDto.fromJS(item));
            }
            if (Array.isArray(_data["clientPermissions"])) {
                this.clientPermissions = [];
                for (let item of _data["clientPermissions"])
                    this.clientPermissions.push(PermissionSetClientDto.fromJS(item));
            }
            if (Array.isArray(_data["userPermissions"])) {
                this.userPermissions = [];
                for (let item of _data["userPermissions"])
                    this.userPermissions.push(item);
            }
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionSetDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version;
        if (Array.isArray(this.groupPermissions)) {
            data["groupPermissions"] = [];
            for (let item of this.groupPermissions)
                data["groupPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.clientPermissions)) {
            data["clientPermissions"] = [];
            for (let item of this.clientPermissions)
                data["clientPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.userPermissions)) {
            data["userPermissions"] = [];
            for (let item of this.userPermissions)
                data["userPermissions"].push(item);
        }
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new PermissionSetDto();
        result.init(json);
        return result;
    }
}
export class GroupDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.name = _data["name"];
            this.role = _data["role"];
            this.encryption = _data["encryption"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["role"] = this.role;
        data["encryption"] = this.encryption;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new GroupDto();
        result.init(json);
        return result;
    }
}
export class PermissionSetClientDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.role = _data["role"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionSetClientDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["role"] = this.role;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new PermissionSetClientDto();
        result.init(json);
        return result;
    }
}
export class ContentTypeDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.properties = new ContentTypePropertiesDto();
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.section = _data["section"];
            this.properties = _data["properties"] ? ContentTypePropertiesDto.fromJS(_data["properties"]) : new ContentTypePropertiesDto();
            this.isSingleton = _data["isSingleton"];
            this.isPublished = _data["isPublished"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined;
            this.version = _data["version"];
            this.hasEncryptedFields = _data["hasEncryptedFields"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentTypeDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["section"] = this.section;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        data["isSingleton"] = this.isSingleton;
        data["isPublished"] = this.isPublished;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["version"] = this.version;
        data["hasEncryptedFields"] = this.hasEncryptedFields;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentTypeDto();
        result.init(json);
        return result;
    }
}
export class ContentTypeDetailsDto extends ContentTypeDto {
    constructor(data) {
        super(data);
        if (!data) {
            this.scripts = new ContentTypeScriptsDto();
            this.previewUrls = {};
            this.fieldsInLists = [];
            this.fieldsInReferences = [];
            this.fields = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.scripts = _data["scripts"] ? ContentTypeScriptsDto.fromJS(_data["scripts"]) : new ContentTypeScriptsDto();
            if (_data["previewUrls"]) {
                this.previewUrls = {};
                for (let key in _data["previewUrls"]) {
                    if (_data["previewUrls"].hasOwnProperty(key))
                        this.previewUrls[key] = _data["previewUrls"][key];
                }
            }
            if (Array.isArray(_data["fieldsInLists"])) {
                this.fieldsInLists = [];
                for (let item of _data["fieldsInLists"])
                    this.fieldsInLists.push(item);
            }
            if (Array.isArray(_data["fieldsInReferences"])) {
                this.fieldsInReferences = [];
                for (let item of _data["fieldsInReferences"])
                    this.fieldsInReferences.push(item);
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [];
                for (let item of _data["fields"])
                    this.fields.push(FieldDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentTypeDetailsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["scripts"] = this.scripts ? this.scripts.toJSON() : undefined;
        if (this.previewUrls) {
            data["previewUrls"] = {};
            for (let key in this.previewUrls) {
                if (this.previewUrls.hasOwnProperty(key))
                    data["previewUrls"][key] = this.previewUrls[key];
            }
        }
        if (Array.isArray(this.fieldsInLists)) {
            data["fieldsInLists"] = [];
            for (let item of this.fieldsInLists)
                data["fieldsInLists"].push(item);
        }
        if (Array.isArray(this.fieldsInReferences)) {
            data["fieldsInReferences"] = [];
            for (let item of this.fieldsInReferences)
                data["fieldsInReferences"].push(item);
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentTypeDetailsDto();
        result.init(json);
        return result;
    }
}
export class ContentTypeScriptsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.query = _data["query"];
            this.create = _data["create"];
            this.update = _data["update"];
            this.delete = _data["delete"];
            this.change = _data["change"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentTypeScriptsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["create"] = this.create;
        data["update"] = this.update;
        data["delete"] = this.delete;
        data["change"] = this.change;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentTypeScriptsDto();
        result.init(json);
        return result;
    }
}
export class FieldDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.name = _data["name"];
            this.isHidden = _data["isHidden"];
            this.isLocked = _data["isLocked"];
            this.isDisabled = _data["isDisabled"];
            this.isEncrypted = _data["isEncrypted"];
            this.partitioning = _data["partitioning"];
            this.properties = _data["properties"] ? FieldPropertiesDto.fromJS(_data["properties"]) : undefined;
            if (Array.isArray(_data["nested"])) {
                this.nested = [];
                for (let item of _data["nested"])
                    this.nested.push(NestedFieldDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FieldDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["name"] = this.name;
        data["isHidden"] = this.isHidden;
        data["isLocked"] = this.isLocked;
        data["isDisabled"] = this.isDisabled;
        data["isEncrypted"] = this.isEncrypted;
        data["partitioning"] = this.partitioning;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        if (Array.isArray(this.nested)) {
            data["nested"] = [];
            for (let item of this.nested)
                data["nested"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new FieldDto();
        result.init(json);
        return result;
    }
}
export class FieldPropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        this._discriminator = "FieldPropertiesDto";
    }
    get fieldType() {
        return this._discriminator;
    }
    init(_data) {
        if (_data) {
            this.label = _data["label"];
            this.hints = _data["hints"];
            this.placeholder = _data["placeholder"];
            this.isRequired = _data["isRequired"];
            this.editorUrl = _data["editorUrl"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        if (data["fieldType"] === "Array") {
            let result = new ArrayFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Assets") {
            let result = new AssetsFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Boolean") {
            let result = new BooleanFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "DateTime") {
            let result = new DateTimeFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "DateTimeRange") {
            let result = new DateTimeRangeFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Geolocation") {
            let result = new GeolocationFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Json") {
            let result = new JsonFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Link") {
            let result = new LinkFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Multi") {
            let result = new MultiFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Number") {
            let result = new NumberFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "NumberRange") {
            let result = new NumberRangeFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "References") {
            let result = new ReferencesFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "String") {
            let result = new StringFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "Tags") {
            let result = new TagsFieldPropertiesDto();
            result.init(data);
            return result;
        }
        if (data["fieldType"] === "UI") {
            let result = new UIFieldPropertiesDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'FieldPropertiesDto' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fieldType"] = this._discriminator;
        data["label"] = this.label;
        data["hints"] = this.hints;
        data["placeholder"] = this.placeholder;
        data["isRequired"] = this.isRequired;
        data["editorUrl"] = this.editorUrl;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
    clone() {
        throw new Error("The abstract class 'FieldPropertiesDto' cannot be instantiated.");
    }
}
export class ArrayFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Array";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.minItems = _data["minItems"];
            this.maxItems = _data["maxItems"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArrayFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["minItems"] = this.minItems;
        data["maxItems"] = this.maxItems;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ArrayFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export class AssetsFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Assets";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.minItems = _data["minItems"];
            this.maxItems = _data["maxItems"];
            this.minSize = _data["minSize"];
            this.maxSize = _data["maxSize"];
            this.minWidth = _data["minWidth"];
            this.maxWidth = _data["maxWidth"];
            this.minHeight = _data["minHeight"];
            this.maxHeight = _data["maxHeight"];
            this.aspectWidth = _data["aspectWidth"];
            this.aspectHeight = _data["aspectHeight"];
            this.mustBeImage = _data["mustBeImage"];
            this.resolveFirst = _data["resolveFirst"];
            this.resolveImage = _data["resolveImage"];
            if (Array.isArray(_data["allowedExtensions"])) {
                this.allowedExtensions = [];
                for (let item of _data["allowedExtensions"])
                    this.allowedExtensions.push(item);
            }
            this.allowDuplicates = _data["allowDuplicates"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["minItems"] = this.minItems;
        data["maxItems"] = this.maxItems;
        data["minSize"] = this.minSize;
        data["maxSize"] = this.maxSize;
        data["minWidth"] = this.minWidth;
        data["maxWidth"] = this.maxWidth;
        data["minHeight"] = this.minHeight;
        data["maxHeight"] = this.maxHeight;
        data["aspectWidth"] = this.aspectWidth;
        data["aspectHeight"] = this.aspectHeight;
        data["mustBeImage"] = this.mustBeImage;
        data["resolveFirst"] = this.resolveFirst;
        data["resolveImage"] = this.resolveImage;
        if (Array.isArray(this.allowedExtensions)) {
            data["allowedExtensions"] = [];
            for (let item of this.allowedExtensions)
                data["allowedExtensions"].push(item);
        }
        data["allowDuplicates"] = this.allowDuplicates;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AssetsFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export class BooleanFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Boolean";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.defaultValue = _data["defaultValue"];
            this.inlineEditable = _data["inlineEditable"];
            this.editor = _data["editor"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        data["inlineEditable"] = this.inlineEditable;
        data["editor"] = this.editor;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new BooleanFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var BooleanFieldEditor;
(function (BooleanFieldEditor) {
    BooleanFieldEditor["Checkbox"] = "Checkbox";
    BooleanFieldEditor["Toggle"] = "Toggle";
})(BooleanFieldEditor || (BooleanFieldEditor = {}));
export class DateTimeFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "DateTime";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.defaultValue = _data["defaultValue"] ? new Date(_data["defaultValue"].toString()) : undefined;
            this.maxValue = _data["maxValue"] ? new Date(_data["maxValue"].toString()) : undefined;
            this.minValue = _data["minValue"] ? new Date(_data["minValue"].toString()) : undefined;
            this.editor = _data["editor"];
            this.calculatedDefaultValue = _data["calculatedDefaultValue"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue ? this.defaultValue.toISOString() : undefined;
        data["maxValue"] = this.maxValue ? this.maxValue.toISOString() : undefined;
        data["minValue"] = this.minValue ? this.minValue.toISOString() : undefined;
        data["editor"] = this.editor;
        data["calculatedDefaultValue"] = this.calculatedDefaultValue;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new DateTimeFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var DateTimeFieldEditor;
(function (DateTimeFieldEditor) {
    DateTimeFieldEditor["Date"] = "Date";
    DateTimeFieldEditor["DateTime"] = "DateTime";
})(DateTimeFieldEditor || (DateTimeFieldEditor = {}));
export var DateTimeCalculatedDefaultValue;
(function (DateTimeCalculatedDefaultValue) {
    DateTimeCalculatedDefaultValue["Now"] = "Now";
    DateTimeCalculatedDefaultValue["Today"] = "Today";
})(DateTimeCalculatedDefaultValue || (DateTimeCalculatedDefaultValue = {}));
export class DateTimeRangeFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "DateTimeRange";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.editor = _data["editor"];
            this.allowRecurring = _data["allowRecurring"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeRangeFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["editor"] = this.editor;
        data["allowRecurring"] = this.allowRecurring;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new DateTimeRangeFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var DateTimeRangeFieldEditor;
(function (DateTimeRangeFieldEditor) {
    DateTimeRangeFieldEditor["DateRange"] = "DateRange";
    DateTimeRangeFieldEditor["DateTimeRange"] = "DateTimeRange";
})(DateTimeRangeFieldEditor || (DateTimeRangeFieldEditor = {}));
export class GeolocationFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Geolocation";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.defaultValue = _data["defaultValue"];
            this.showAddress1 = _data["showAddress1"];
            this.showAddress2 = _data["showAddress2"];
            this.showCity = _data["showCity"];
            this.showState = _data["showState"];
            this.showZipCode = _data["showZipCode"];
            this.zipCodePattern = _data["zipCodePattern"];
            this.zipCodePatternMessage = _data["zipCodePatternMessage"];
            this.statePattern = _data["statePattern"];
            this.statePatternMessage = _data["statePatternMessage"];
            this.editor = _data["editor"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GeolocationFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        data["showAddress1"] = this.showAddress1;
        data["showAddress2"] = this.showAddress2;
        data["showCity"] = this.showCity;
        data["showState"] = this.showState;
        data["showZipCode"] = this.showZipCode;
        data["zipCodePattern"] = this.zipCodePattern;
        data["zipCodePatternMessage"] = this.zipCodePatternMessage;
        data["statePattern"] = this.statePattern;
        data["statePatternMessage"] = this.statePatternMessage;
        data["editor"] = this.editor;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new GeolocationFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var GeolocationFieldEditor;
(function (GeolocationFieldEditor) {
    GeolocationFieldEditor["Map"] = "Map";
    GeolocationFieldEditor["NoMap"] = "NoMap";
})(GeolocationFieldEditor || (GeolocationFieldEditor = {}));
export class JsonFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Json";
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new JsonFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new JsonFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export class LinkFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Link";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.editor = _data["editor"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LinkFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["editor"] = this.editor;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new LinkFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var LinkFieldEditor;
(function (LinkFieldEditor) {
    LinkFieldEditor["Link"] = "Link";
})(LinkFieldEditor || (LinkFieldEditor = {}));
export class MultiFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Multi";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allowedValues"])) {
                this.allowedValues = [];
                for (let item of _data["allowedValues"])
                    this.allowedValues.push(item);
            }
            if (Array.isArray(_data["defaultValue"])) {
                this.defaultValue = [];
                for (let item of _data["defaultValue"])
                    this.defaultValue.push(item);
            }
            this.editor = _data["editor"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new MultiFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedValues)) {
            data["allowedValues"] = [];
            for (let item of this.allowedValues)
                data["allowedValues"].push(item);
        }
        if (Array.isArray(this.defaultValue)) {
            data["defaultValue"] = [];
            for (let item of this.defaultValue)
                data["defaultValue"].push(item);
        }
        data["editor"] = this.editor;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new MultiFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var MultiFieldEditor;
(function (MultiFieldEditor) {
    MultiFieldEditor["Multi"] = "Multi";
})(MultiFieldEditor || (MultiFieldEditor = {}));
export class NumberFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Number";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.defaultValue = _data["defaultValue"];
            this.maxValue = _data["maxValue"];
            this.minValue = _data["minValue"];
            if (Array.isArray(_data["allowedValues"])) {
                this.allowedValues = [];
                for (let item of _data["allowedValues"])
                    this.allowedValues.push(item);
            }
            this.isUnique = _data["isUnique"];
            this.inlineEditable = _data["inlineEditable"];
            this.editor = _data["editor"];
            this.mask = _data["mask"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NumberFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        data["maxValue"] = this.maxValue;
        data["minValue"] = this.minValue;
        if (Array.isArray(this.allowedValues)) {
            data["allowedValues"] = [];
            for (let item of this.allowedValues)
                data["allowedValues"].push(item);
        }
        data["isUnique"] = this.isUnique;
        data["inlineEditable"] = this.inlineEditable;
        data["editor"] = this.editor;
        data["mask"] = this.mask;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new NumberFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var NumberFieldEditor;
(function (NumberFieldEditor) {
    NumberFieldEditor["Input"] = "Input";
    NumberFieldEditor["Radio"] = "Radio";
    NumberFieldEditor["Dropdown"] = "Dropdown";
    NumberFieldEditor["Stars"] = "Stars";
    NumberFieldEditor["MaskedInput"] = "MaskedInput";
})(NumberFieldEditor || (NumberFieldEditor = {}));
export class NumberRangeFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "NumberRange";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.mask = _data["mask"];
            this.maxValue = _data["maxValue"];
            this.minValue = _data["minValue"];
            this.placeholderFrom = _data["placeholderFrom"];
            this.placeholderTo = _data["placeholderTo"];
            this.editor = _data["editor"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NumberRangeFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["mask"] = this.mask;
        data["maxValue"] = this.maxValue;
        data["minValue"] = this.minValue;
        data["placeholderFrom"] = this.placeholderFrom;
        data["placeholderTo"] = this.placeholderTo;
        data["editor"] = this.editor;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new NumberRangeFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var NumberRangeFieldEditor;
(function (NumberRangeFieldEditor) {
    NumberRangeFieldEditor["Number"] = "Number";
    NumberRangeFieldEditor["MaskedInput"] = "MaskedInput";
})(NumberRangeFieldEditor || (NumberRangeFieldEditor = {}));
export class ReferencesFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "References";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.minItems = _data["minItems"];
            this.maxItems = _data["maxItems"];
            this.allowDuplicates = _data["allowDuplicates"];
            this.resolveReference = _data["resolveReference"];
            this.editor = _data["editor"];
            if (Array.isArray(_data["contentTypeIds"])) {
                this.contentTypeIds = [];
                for (let item of _data["contentTypeIds"])
                    this.contentTypeIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReferencesFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["minItems"] = this.minItems;
        data["maxItems"] = this.maxItems;
        data["allowDuplicates"] = this.allowDuplicates;
        data["resolveReference"] = this.resolveReference;
        data["editor"] = this.editor;
        if (Array.isArray(this.contentTypeIds)) {
            data["contentTypeIds"] = [];
            for (let item of this.contentTypeIds)
                data["contentTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ReferencesFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var ReferencesFieldEditor;
(function (ReferencesFieldEditor) {
    ReferencesFieldEditor["List"] = "List";
    ReferencesFieldEditor["Dropdown"] = "Dropdown";
    ReferencesFieldEditor["Tags"] = "Tags";
    ReferencesFieldEditor["Checkboxes"] = "Checkboxes";
    ReferencesFieldEditor["Modal"] = "Modal";
    ReferencesFieldEditor["Form"] = "Form";
})(ReferencesFieldEditor || (ReferencesFieldEditor = {}));
export class StringFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "String";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.defaultValue = _data["defaultValue"];
            this.pattern = _data["pattern"];
            this.patternMessage = _data["patternMessage"];
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            if (Array.isArray(_data["allowedValues"])) {
                this.allowedValues = [];
                for (let item of _data["allowedValues"])
                    this.allowedValues.push(item);
            }
            this.isUnique = _data["isUnique"];
            this.inlineEditable = _data["inlineEditable"];
            this.editor = _data["editor"];
            this.mask = _data["mask"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StringFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        data["pattern"] = this.pattern;
        data["patternMessage"] = this.patternMessage;
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        if (Array.isArray(this.allowedValues)) {
            data["allowedValues"] = [];
            for (let item of this.allowedValues)
                data["allowedValues"].push(item);
        }
        data["isUnique"] = this.isUnique;
        data["inlineEditable"] = this.inlineEditable;
        data["editor"] = this.editor;
        data["mask"] = this.mask;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new StringFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var StringFieldEditor;
(function (StringFieldEditor) {
    StringFieldEditor["Input"] = "Input";
    StringFieldEditor["Markdown"] = "Markdown";
    StringFieldEditor["Dropdown"] = "Dropdown";
    StringFieldEditor["Radio"] = "Radio";
    StringFieldEditor["RichText"] = "RichText";
    StringFieldEditor["Slug"] = "Slug";
    StringFieldEditor["TextArea"] = "TextArea";
    StringFieldEditor["MaskedInput"] = "MaskedInput";
    StringFieldEditor["Color"] = "Color";
    StringFieldEditor["Html"] = "Html";
    StringFieldEditor["StockPhoto"] = "StockPhoto";
})(StringFieldEditor || (StringFieldEditor = {}));
export class TagsFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "Tags";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.minItems = _data["minItems"];
            this.maxItems = _data["maxItems"];
            if (Array.isArray(_data["allowedValues"])) {
                this.allowedValues = [];
                for (let item of _data["allowedValues"])
                    this.allowedValues.push(item);
            }
            this.editor = _data["editor"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TagsFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["minItems"] = this.minItems;
        data["maxItems"] = this.maxItems;
        if (Array.isArray(this.allowedValues)) {
            data["allowedValues"] = [];
            for (let item of this.allowedValues)
                data["allowedValues"].push(item);
        }
        data["editor"] = this.editor;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new TagsFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var TagsFieldEditor;
(function (TagsFieldEditor) {
    TagsFieldEditor["Tags"] = "Tags";
    TagsFieldEditor["Checkboxes"] = "Checkboxes";
    TagsFieldEditor["Dropdown"] = "Dropdown";
})(TagsFieldEditor || (TagsFieldEditor = {}));
export class UIFieldPropertiesDto extends FieldPropertiesDto {
    constructor(data) {
        super(data);
        this._discriminator = "UI";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.editor = _data["editor"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UIFieldPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["editor"] = this.editor;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UIFieldPropertiesDto();
        result.init(json);
        return result;
    }
}
export var UIFieldEditor;
(function (UIFieldEditor) {
    UIFieldEditor["Separator"] = "Separator";
})(UIFieldEditor || (UIFieldEditor = {}));
export class NestedFieldDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.fieldId = _data["fieldId"];
            this.name = _data["name"];
            this.isHidden = _data["isHidden"];
            this.isLocked = _data["isLocked"];
            this.isDisabled = _data["isDisabled"];
            this.isEncrypted = _data["isEncrypted"];
            this.properties = _data["properties"] ? FieldPropertiesDto.fromJS(_data["properties"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NestedFieldDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fieldId"] = this.fieldId;
        data["name"] = this.name;
        data["isHidden"] = this.isHidden;
        data["isLocked"] = this.isLocked;
        data["isDisabled"] = this.isDisabled;
        data["isEncrypted"] = this.isEncrypted;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new NestedFieldDto();
        result.init(json);
        return result;
    }
}
export class ContentTypePropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.label = _data["label"];
            this.hints = _data["hints"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentTypePropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["hints"] = this.hints;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentTypePropertiesDto();
        result.init(json);
        return result;
    }
}
export class AddFieldDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.partitioning = _data["partitioning"];
            this.properties = _data["properties"] ? FieldPropertiesDto.fromJS(_data["properties"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddFieldDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["partitioning"] = this.partitioning;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AddFieldDto();
        result.init(json);
        return result;
    }
}
export class ConfigureUIFieldsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["fieldsInLists"])) {
                this.fieldsInLists = [];
                for (let item of _data["fieldsInLists"])
                    this.fieldsInLists.push(item);
            }
            if (Array.isArray(_data["fieldsInReferences"])) {
                this.fieldsInReferences = [];
                for (let item of _data["fieldsInReferences"])
                    this.fieldsInReferences.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigureUIFieldsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldsInLists)) {
            data["fieldsInLists"] = [];
            for (let item of this.fieldsInLists)
                data["fieldsInLists"].push(item);
        }
        if (Array.isArray(this.fieldsInReferences)) {
            data["fieldsInReferences"] = [];
            for (let item of this.fieldsInReferences)
                data["fieldsInReferences"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ConfigureUIFieldsDto();
        result.init(json);
        return result;
    }
}
export class ReorderFieldsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.fieldIds = [];
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["fieldIds"])) {
                this.fieldIds = [];
                for (let item of _data["fieldIds"])
                    this.fieldIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ReorderFieldsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fieldIds)) {
            data["fieldIds"] = [];
            for (let item of this.fieldIds)
                data["fieldIds"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ReorderFieldsDto();
        result.init(json);
        return result;
    }
}
export class UpdateFieldDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.properties = _data["properties"] ? FieldPropertiesDto.fromJS(_data["properties"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFieldDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateFieldDto();
        result.init(json);
        return result;
    }
}
export class ErrorDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.message = _data["message"];
            this.traceId = _data["traceId"];
            this.type = _data["type"];
            if (Array.isArray(_data["details"])) {
                this.details = [];
                for (let item of _data["details"])
                    this.details.push(item);
            }
            this.statusCode = _data["statusCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["traceId"] = this.traceId;
        data["type"] = this.type;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item);
        }
        data["statusCode"] = this.statusCode;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ErrorDto();
        result.init(json);
        return result;
    }
}
export class ContentTypesDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ContentTypeDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentTypesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentTypesDto();
        result.init(json);
        return result;
    }
}
export class UpsertContentTypeDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.properties = _data["properties"] ? ContentTypePropertiesDto.fromJS(_data["properties"]) : undefined;
            this.scripts = _data["scripts"] ? ContentTypeScriptsDto.fromJS(_data["scripts"]) : undefined;
            if (Array.isArray(_data["fieldsInReferences"])) {
                this.fieldsInReferences = [];
                for (let item of _data["fieldsInReferences"])
                    this.fieldsInReferences.push(item);
            }
            if (Array.isArray(_data["fieldsInLists"])) {
                this.fieldsInLists = [];
                for (let item of _data["fieldsInLists"])
                    this.fieldsInLists.push(item);
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [];
                for (let item of _data["fields"])
                    this.fields.push(UpsertContentTypeFieldDto.fromJS(item));
            }
            if (_data["previewUrls"]) {
                this.previewUrls = {};
                for (let key in _data["previewUrls"]) {
                    if (_data["previewUrls"].hasOwnProperty(key))
                        this.previewUrls[key] = _data["previewUrls"][key];
                }
            }
            this.category = _data["category"];
            this.isPublished = _data["isPublished"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UpsertContentTypeDto' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        data["scripts"] = this.scripts ? this.scripts.toJSON() : undefined;
        if (Array.isArray(this.fieldsInReferences)) {
            data["fieldsInReferences"] = [];
            for (let item of this.fieldsInReferences)
                data["fieldsInReferences"].push(item);
        }
        if (Array.isArray(this.fieldsInLists)) {
            data["fieldsInLists"] = [];
            for (let item of this.fieldsInLists)
                data["fieldsInLists"].push(item);
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        if (this.previewUrls) {
            data["previewUrls"] = {};
            for (let key in this.previewUrls) {
                if (this.previewUrls.hasOwnProperty(key))
                    data["previewUrls"][key] = this.previewUrls[key];
            }
        }
        data["category"] = this.category;
        data["isPublished"] = this.isPublished;
        return data;
    }
    clone() {
        throw new Error("The abstract class 'UpsertContentTypeDto' cannot be instantiated.");
    }
}
export class CreateContentTypeDto extends UpsertContentTypeDto {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.isSingleton = _data["isSingleton"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContentTypeDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSingleton"] = this.isSingleton;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CreateContentTypeDto();
        result.init(json);
        return result;
    }
}
export class UpsertContentTypeFieldDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.isHidden = _data["isHidden"];
            this.isLocked = _data["isLocked"];
            this.isDisabled = _data["isDisabled"];
            this.isEncrypted = _data["isEncrypted"];
            this.partitioning = _data["partitioning"];
            this.properties = _data["properties"] ? FieldPropertiesDto.fromJS(_data["properties"]) : undefined;
            if (Array.isArray(_data["nested"])) {
                this.nested = [];
                for (let item of _data["nested"])
                    this.nested.push(UpsertContentTypeNestedFieldDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertContentTypeFieldDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isHidden"] = this.isHidden;
        data["isLocked"] = this.isLocked;
        data["isDisabled"] = this.isDisabled;
        data["isEncrypted"] = this.isEncrypted;
        data["partitioning"] = this.partitioning;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        if (Array.isArray(this.nested)) {
            data["nested"] = [];
            for (let item of this.nested)
                data["nested"].push(item.toJSON());
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpsertContentTypeFieldDto();
        result.init(json);
        return result;
    }
}
export class UpsertContentTypeNestedFieldDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.isHidden = _data["isHidden"];
            this.isLocked = _data["isLocked"];
            this.isDisabled = _data["isDisabled"];
            this.isEncrypted = _data["isEncrypted"];
            this.properties = _data["properties"] ? FieldPropertiesDto.fromJS(_data["properties"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertContentTypeNestedFieldDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isHidden"] = this.isHidden;
        data["isLocked"] = this.isLocked;
        data["isDisabled"] = this.isDisabled;
        data["isEncrypted"] = this.isEncrypted;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpsertContentTypeNestedFieldDto();
        result.init(json);
        return result;
    }
}
export class UpdateContentTypeDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.label = _data["label"];
            this.hints = _data["hints"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContentTypeDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["hints"] = this.hints;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateContentTypeDto();
        result.init(json);
        return result;
    }
}
export class SynchronizeContentTypeDto extends UpsertContentTypeDto {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.noFieldDeletion = _data["noFieldDeletion"];
            this.noFieldRecreation = _data["noFieldRecreation"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeContentTypeDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["noFieldDeletion"] = this.noFieldDeletion;
        data["noFieldRecreation"] = this.noFieldRecreation;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new SynchronizeContentTypeDto();
        result.init(json);
        return result;
    }
}
export class ChangeCategoryDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCategoryDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ChangeCategoryDto();
        result.init(json);
        return result;
    }
}
export class ConfigurePreviewUrlsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurePreviewUrlsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ConfigurePreviewUrlsDto();
        result.init(json);
        return result;
    }
}
export class PermissionSetsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(PermissionSetDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionSetsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new PermissionSetsDto();
        result.init(json);
        return result;
    }
}
export class PermissionSetRequestDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionSetRequestDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new PermissionSetRequestDto();
        result.init(json);
        return result;
    }
}
/** Dto to Update Permission Set Group Permission. */
export class UpdatePermissionSetGroupDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.role = _data["role"];
            this.encryption = _data["encryption"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePermissionSetGroupDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["role"] = this.role;
        data["encryption"] = this.encryption;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdatePermissionSetGroupDto();
        result.init(json);
        return result;
    }
}
export class ProblemDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {};
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions[key] = _data["extensions"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}
/** Dto to Update Permission Set Client Permission. */
export class UpdatePermissionSetClientDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.role = _data["role"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePermissionSetClientDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["role"] = this.role;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdatePermissionSetClientDto();
        result.init(json);
        return result;
    }
}
export class LanguageDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.iso2Code = _data["iso2Code"];
            this.englishName = _data["englishName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["iso2Code"] = this.iso2Code;
        data["englishName"] = this.englishName;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}
export class HistoryEventDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.message = _data["message"];
            this.eventType = _data["eventType"];
            this.actor = _data["actor"];
            this.eventId = _data["eventId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryEventDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["eventType"] = this.eventType;
        data["actor"] = this.actor;
        data["eventId"] = this.eventId;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["version"] = this.version;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new HistoryEventDto();
        result.init(json);
        return result;
    }
}
export class GraphQLQuery {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.operationName = _data["operationName"];
            this.query = _data["query"];
            this.variables = _data["variables"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GraphQLQuery();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["operationName"] = this.operationName;
        data["query"] = this.query;
        data["variables"] = this.variables;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new GraphQLQuery();
        result.init(json);
        return result;
    }
}
export class ContentsDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
            this.statuses = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ContentDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [];
                for (let item of _data["statuses"])
                    this.statuses.push(StatusInfoDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentsDto();
        result.init(json);
        return result;
    }
}
export class ContentDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.data = _data["data"];
            this.referenceData = _data["referenceData"] ? NamedContentData.fromJS(_data["referenceData"]) : undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined;
            this.status = _data["status"];
            this.newStatus = _data["newStatus"];
            this.statusColor = _data["statusColor"];
            this.newStatusColor = _data["newStatusColor"];
            this.scheduleJob = _data["scheduleJob"] ? ScheduleJobDto.fromJS(_data["scheduleJob"]) : undefined;
            this.contentTypeName = _data["contentTypeName"];
            this.contentTypeDisplayName = _data["contentTypeDisplayName"];
            if (Array.isArray(_data["referenceFields"])) {
                this.referenceFields = [];
                for (let item of _data["referenceFields"])
                    this.referenceFields.push(FieldDto.fromJS(item));
            }
            this.version = _data["version"];
            this.scheduleJobEnd = _data["scheduleJobEnd"] ? ScheduleJobDto.fromJS(_data["scheduleJobEnd"]) : undefined;
            this.contentTypeId = _data["contentTypeId"] ? NamedIdOfGuid.fromJS(_data["contentTypeId"]) : undefined;
            if (Array.isArray(_data["tagsDeleted"])) {
                this.tagsDeleted = [];
                for (let item of _data["tagsDeleted"])
                    this.tagsDeleted.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (let item of _data["categories"])
                    this.categories.push(Category.fromJS(item));
            }
            this.permissionSet = _data["permissionSet"] ? PermissionSetDto.fromJS(_data["permissionSet"]) : undefined;
            this.highlight = _data["highlight"];
            this.notificationDetails = _data["notificationDetails"] ? NotificationDetails.fromJS(_data["notificationDetails"]) : undefined;
            this.isEncrypted = _data["isEncrypted"];
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [];
                for (let item of _data["emailAddresses"])
                    this.emailAddresses.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["data"] = this.data;
        data["referenceData"] = this.referenceData ? this.referenceData.toJSON() : undefined;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["status"] = this.status;
        data["newStatus"] = this.newStatus;
        data["statusColor"] = this.statusColor;
        data["newStatusColor"] = this.newStatusColor;
        data["scheduleJob"] = this.scheduleJob ? this.scheduleJob.toJSON() : undefined;
        data["contentTypeName"] = this.contentTypeName;
        data["contentTypeDisplayName"] = this.contentTypeDisplayName;
        if (Array.isArray(this.referenceFields)) {
            data["referenceFields"] = [];
            for (let item of this.referenceFields)
                data["referenceFields"].push(item.toJSON());
        }
        data["version"] = this.version;
        data["scheduleJobEnd"] = this.scheduleJobEnd ? this.scheduleJobEnd.toJSON() : undefined;
        data["contentTypeId"] = this.contentTypeId ? this.contentTypeId.toJSON() : undefined;
        if (Array.isArray(this.tagsDeleted)) {
            data["tagsDeleted"] = [];
            for (let item of this.tagsDeleted)
                data["tagsDeleted"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["permissionSet"] = this.permissionSet ? this.permissionSet.toJSON() : undefined;
        data["highlight"] = this.highlight;
        data["notificationDetails"] = this.notificationDetails ? this.notificationDetails.toJSON() : undefined;
        data["isEncrypted"] = this.isEncrypted;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentDto();
        result.init(json);
        return result;
    }
}
export class ContentDataOfString {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["ValidValues"])) {
                this.validValues = [];
                for (let item of _data["ValidValues"])
                    this.validValues.push(KeyValuePair_2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ContentDataOfString' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.validValues)) {
            data["ValidValues"] = [];
            for (let item of this.validValues)
                data["ValidValues"].push(item.toJSON());
        }
        return data;
    }
    clone() {
        throw new Error("The abstract class 'ContentDataOfString' cannot be instantiated.");
    }
}
export class NamedContentData extends ContentDataOfString {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NamedContentData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new NamedContentData();
        result.init(json);
        return result;
    }
}
export class KeyValuePair_2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"] ? ContentFieldData.fromJS(_data["value"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePair_2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new KeyValuePair_2();
        result.init(json);
        return result;
    }
}
export class ContentFieldData {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.containsEncryptedPlaceholder = _data["ContainsEncryptedPlaceholder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentFieldData();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ContainsEncryptedPlaceholder"] = this.containsEncryptedPlaceholder;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentFieldData();
        result.init(json);
        return result;
    }
}
export class NamedIdOfGuid {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NamedIdOfGuid();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new NamedIdOfGuid();
        result.init(json);
        return result;
    }
}
export class Category {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new Category();
        result.init(json);
        return result;
    }
}
export class NotificationDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.notificationOption = _data["notificationOption"];
            this.daysInAdvance = _data["daysInAdvance"];
            this.subject = _data["subject"];
            this.emailIntroduction = _data["emailIntroduction"];
            this.smsMessage = _data["smsMessage"];
            this.sendAt = _data["sendAt"] ? new Date(_data["sendAt"].toString()) : undefined;
            this.eventType = _data["eventType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["notificationOption"] = this.notificationOption;
        data["daysInAdvance"] = this.daysInAdvance;
        data["subject"] = this.subject;
        data["emailIntroduction"] = this.emailIntroduction;
        data["smsMessage"] = this.smsMessage;
        data["sendAt"] = this.sendAt ? this.sendAt.toISOString() : undefined;
        data["eventType"] = this.eventType;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new NotificationDetails();
        result.init(json);
        return result;
    }
}
export var NotificationOption;
(function (NotificationOption) {
    NotificationOption["None"] = "None";
    NotificationOption["OnPublishDate"] = "OnPublishDate";
    NotificationOption["DaysInAdvance"] = "DaysInAdvance";
})(NotificationOption || (NotificationOption = {}));
export class StatusInfoDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
            this.color = _data["color"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StatusInfoDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["color"] = this.color;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new StatusInfoDto();
        result.init(json);
        return result;
    }
}
export class ContentsIdsQueryDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [];
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContentsIdsQueryDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContentsIdsQueryDto();
        result.init(json);
        return result;
    }
}
export class QueryDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [];
                for (let item of _data["ids"])
                    this.ids.push(item);
            }
            this.oData = _data["oData"];
            this.q = _data["q"];
            this.parentId = _data["parentId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueryDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["oData"] = this.oData;
        data["q"] = this.q;
        data["parentId"] = this.parentId;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new QueryDto();
        result.init(json);
        return result;
    }
}
export class NamedContentDataDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? NamedContentData.fromJS(_data["data"]) : undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (let item of _data["categories"])
                    this.categories.push(Category.fromJS(item));
            }
            this.permissionSet = _data["permissionSet"] ? PermissionSet.fromJS(_data["permissionSet"]) : undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            if (Array.isArray(_data["tagsDeleted"])) {
                this.tagsDeleted = [];
                for (let item of _data["tagsDeleted"])
                    this.tagsDeleted.push(item);
            }
            this.notificationDetails = _data["notificationDetails"] ? NotificationDetails.fromJS(_data["notificationDetails"]) : undefined;
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [];
                for (let item of _data["emailAddresses"])
                    this.emailAddresses.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NamedContentDataDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["permissionSet"] = this.permissionSet ? this.permissionSet.toJSON() : undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.tagsDeleted)) {
            data["tagsDeleted"] = [];
            for (let item of this.tagsDeleted)
                data["tagsDeleted"].push(item);
        }
        data["notificationDetails"] = this.notificationDetails ? this.notificationDetails.toJSON() : undefined;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new NamedContentDataDto();
        result.init(json);
        return result;
    }
}
export class PermissionSet {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionSet();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new PermissionSet();
        result.init(json);
        return result;
    }
}
export class BulkResultDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.error = _data["error"] ? ErrorDto.fromJS(_data["error"]) : undefined;
            this.contentId = _data["contentId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BulkResultDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : undefined;
        data["contentId"] = this.contentId;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new BulkResultDto();
        result.init(json);
        return result;
    }
}
export class BulkUpdateDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.jobs = [];
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [];
                for (let item of _data["jobs"])
                    this.jobs.push(BulkUpdateJobDto.fromJS(item));
            }
            this.publish = _data["publish"];
            this.doNotScript = _data["doNotScript"];
            this.optimizeValidation = _data["optimizeValidation"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        data["publish"] = this.publish;
        data["doNotScript"] = this.doNotScript;
        data["optimizeValidation"] = this.optimizeValidation;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new BulkUpdateDto();
        result.init(json);
        return result;
    }
}
export class BulkUpdateJobDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.query = _data["query"] ? QueryOfIJsonValue.fromJS(_data["query"]) : undefined;
            this.id = _data["id"];
            this.data = _data["data"] ? NamedContentData.fromJS(_data["data"]) : undefined;
            this.status = _data["status"];
            this.type = _data["type"];
            this.permissionSet = _data["permissionSet"] ? PermissionSet.fromJS(_data["permissionSet"]) : undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (let item of _data["categories"])
                    this.categories.push(Category.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.notificationDetails = _data["notificationDetails"] ? NotificationDetails.fromJS(_data["notificationDetails"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateJobDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query ? this.query.toJSON() : undefined;
        data["id"] = this.id;
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["status"] = this.status;
        data["type"] = this.type;
        data["permissionSet"] = this.permissionSet ? this.permissionSet.toJSON() : undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["notificationDetails"] = this.notificationDetails ? this.notificationDetails.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new BulkUpdateJobDto();
        result.init(json);
        return result;
    }
}
export class QueryOfIJsonValue {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.filter = _data["filter"] ? FilterNodeOfIJsonValue.fromJS(_data["filter"]) : undefined;
            this.fullText = _data["fullText"];
            this.skip = _data["skip"];
            this.take = _data["take"];
            this.top = _data["top"];
            if (Array.isArray(_data["sort"])) {
                this.sort = [];
                for (let item of _data["sort"])
                    this.sort.push(SortNode.fromJS(item));
            }
            this.user = _data["user"] ? ClaimsPrincipal.fromJS(_data["user"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QueryOfIJsonValue();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : undefined;
        data["fullText"] = this.fullText;
        data["skip"] = this.skip;
        data["take"] = this.take;
        data["top"] = this.top;
        if (Array.isArray(this.sort)) {
            data["sort"] = [];
            for (let item of this.sort)
                data["sort"].push(item.toJSON());
        }
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new QueryOfIJsonValue();
        result.init(json);
        return result;
    }
}
export class FilterNodeOfIJsonValue {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FilterNodeOfIJsonValue' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
    clone() {
        throw new Error("The abstract class 'FilterNodeOfIJsonValue' cannot be instantiated.");
    }
}
export class SortNode {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["path"])) {
                this.path = [];
                for (let item of _data["path"])
                    this.path.push(item);
            }
            this.order = _data["order"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SortNode();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        data["order"] = this.order;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new SortNode();
        result.init(json);
        return result;
    }
}
export var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "Ascending";
    SortOrder["Descending"] = "Descending";
})(SortOrder || (SortOrder = {}));
export class ClaimsPrincipal {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["claims"])) {
                this.claims = [];
                for (let item of _data["claims"])
                    this.claims.push(Claim.fromJS(item));
            }
            if (Array.isArray(_data["identities"])) {
                this.identities = [];
                for (let item of _data["identities"])
                    this.identities.push(ClaimsIdentity.fromJS(item));
            }
            this.identity = _data["identity"] ? IIdentity.fromJS(_data["identity"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsPrincipal();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.identities)) {
            data["identities"] = [];
            for (let item of this.identities)
                data["identities"].push(item.toJSON());
        }
        data["identity"] = this.identity ? this.identity.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ClaimsPrincipal();
        result.init(json);
        return result;
    }
}
export class Claim {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.originalIssuer = _data["originalIssuer"];
            if (_data["properties"]) {
                this.properties = {};
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        this.properties[key] = _data["properties"][key];
                }
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : undefined;
            this.type = _data["type"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["originalIssuer"] = this.originalIssuer;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : undefined;
        data["type"] = this.type;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new Claim();
        result.init(json);
        return result;
    }
}
export class ClaimsIdentity {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.authenticationType = _data["authenticationType"];
            this.isAuthenticated = _data["isAuthenticated"];
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : undefined;
            this.bootstrapContext = _data["bootstrapContext"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [];
                for (let item of _data["claims"])
                    this.claims.push(Claim.fromJS(item));
            }
            this.label = _data["label"];
            this.name = _data["name"];
            this.nameClaimType = _data["nameClaimType"];
            this.roleClaimType = _data["roleClaimType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        data["actor"] = this.actor ? this.actor.toJSON() : undefined;
        data["bootstrapContext"] = this.bootstrapContext;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label;
        data["name"] = this.name;
        data["nameClaimType"] = this.nameClaimType;
        data["roleClaimType"] = this.roleClaimType;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ClaimsIdentity();
        result.init(json);
        return result;
    }
}
export class IIdentity {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.authenticationType = _data["authenticationType"];
            this.isAuthenticated = _data["isAuthenticated"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IIdentity' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        data["name"] = this.name;
        return data;
    }
    clone() {
        throw new Error("The abstract class 'IIdentity' cannot be instantiated.");
    }
}
export var BulkUpdateType;
(function (BulkUpdateType) {
    BulkUpdateType["Upsert"] = "Upsert";
    BulkUpdateType["ChangeStatus"] = "ChangeStatus";
    BulkUpdateType["Delete"] = "Delete";
})(BulkUpdateType || (BulkUpdateType = {}));
export class ChangeStatusDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
            this.dueTime = _data["dueTime"] ? new Date(_data["dueTime"].toString()) : undefined;
            this.notificationDetails = _data["notificationDetails"] ? NotificationDetails.fromJS(_data["notificationDetails"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeStatusDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["dueTime"] = this.dueTime ? this.dueTime.toISOString() : undefined;
        data["notificationDetails"] = this.notificationDetails ? this.notificationDetails.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ChangeStatusDto();
        result.init(json);
        return result;
    }
}
export class CategoriesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(CategoryDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CategoriesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CategoriesDto();
        result.init(json);
        return result;
    }
}
export class CategoryDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.version = _data["version"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CategoryDto();
        result.init(json);
        return result;
    }
}
export class CategoryRequestDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryRequestDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CategoryRequestDto();
        result.init(json);
        return result;
    }
}
export class BackupJobsDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(BackupJobDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BackupJobsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new BackupJobsDto();
        result.init(json);
        return result;
    }
}
export class BackupJobDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.started = _data["started"] ? new Date(_data["started"].toString()) : undefined;
            this.stopped = _data["stopped"] ? new Date(_data["stopped"].toString()) : undefined;
            this.handledEvents = _data["handledEvents"];
            this.handledAssets = _data["handledAssets"];
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BackupJobDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["started"] = this.started ? this.started.toISOString() : undefined;
        data["stopped"] = this.stopped ? this.stopped.toISOString() : undefined;
        data["handledEvents"] = this.handledEvents;
        data["handledAssets"] = this.handledAssets;
        data["status"] = this.status;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new BackupJobDto();
        result.init(json);
        return result;
    }
}
export var JobStatus;
(function (JobStatus) {
    JobStatus["Created"] = "Created";
    JobStatus["Started"] = "Started";
    JobStatus["Completed"] = "Completed";
    JobStatus["Failed"] = "Failed";
})(JobStatus || (JobStatus = {}));
export class RestoreJobDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.log = [];
        }
    }
    init(_data) {
        if (_data) {
            this.url = _data["url"];
            if (Array.isArray(_data["log"])) {
                this.log = [];
                for (let item of _data["log"])
                    this.log.push(item);
            }
            this.started = _data["started"] ? new Date(_data["started"].toString()) : undefined;
            this.stopped = _data["stopped"] ? new Date(_data["stopped"].toString()) : undefined;
            this.status = _data["status"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreJobDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        if (Array.isArray(this.log)) {
            data["log"] = [];
            for (let item of this.log)
                data["log"].push(item);
        }
        data["started"] = this.started ? this.started.toISOString() : undefined;
        data["stopped"] = this.stopped ? this.stopped.toISOString() : undefined;
        data["status"] = this.status;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new RestoreJobDto();
        result.init(json);
        return result;
    }
}
export class RestoreRequestDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RestoreRequestDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new RestoreRequestDto();
        result.init(json);
        return result;
    }
}
export var ResizeMode;
(function (ResizeMode) {
    ResizeMode["Crop"] = "Crop";
    ResizeMode["CropUpsize"] = "CropUpsize";
    ResizeMode["Pad"] = "Pad";
    ResizeMode["BoxPad"] = "BoxPad";
    ResizeMode["Max"] = "Max";
    ResizeMode["Min"] = "Min";
    ResizeMode["Stretch"] = "Stretch";
})(ResizeMode || (ResizeMode = {}));
export var SearchScope;
(function (SearchScope) {
    SearchScope["All"] = "All";
    SearchScope["Published"] = "Published";
})(SearchScope || (SearchScope = {}));
export class AssetsDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
            this.statuses = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(AssetDto.fromJS(item));
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [];
                for (let item of _data["statuses"])
                    this.statuses.push(StatusInfoDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AssetsDto();
        result.init(json);
        return result;
    }
}
export class AssetDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.metadata = {};
            this.tags = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.parentId = _data["parentId"];
            this.fileName = _data["fileName"];
            this.fileHash = _data["fileHash"];
            this.isProtected = _data["isProtected"];
            this.slug = _data["slug"];
            this.mimeType = _data["mimeType"];
            this.fileType = _data["fileType"];
            this.fileExtension = _data["fileExtension"];
            this.metadataText = _data["metadataText"];
            if (_data["metadata"]) {
                this.metadata = {};
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.fileSize = _data["fileSize"];
            this.fileVersion = _data["fileVersion"];
            this.type = _data["type"];
            this.createdBy = _data["createdBy"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined;
            this.version = _data["version"];
            this._meta = _data["_meta"] ? AssetMeta.fromJS(_data["_meta"]) : undefined;
            this.isImage = _data["isImage"];
            this.pixelWidth = _data["pixelWidth"];
            this.pixelHeight = _data["pixelHeight"];
            this.newStatus = _data["newStatus"];
            this.statusColor = _data["statusColor"];
            this.newStatusColor = _data["newStatusColor"];
            this.briefDescription = _data["briefDescription"];
            this.status = _data["status"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (let item of _data["categories"])
                    this.categories.push(Category.fromJS(item));
            }
            this.highlight = _data["highlight"];
            this.scheduleJob = _data["scheduleJob"] ? ScheduleJobDto.fromJS(_data["scheduleJob"]) : undefined;
            this.transcript = _data["transcript"];
            this.isPending = _data["isPending"];
            this.permissionSet = _data["permissionSet"] ? PermissionSetDto.fromJS(_data["permissionSet"]) : undefined;
            this.notificationDetails = _data["notificationDetails"] ? NotificationDetails.fromJS(_data["notificationDetails"]) : undefined;
            this.isEncrypted = _data["isEncrypted"];
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [];
                for (let item of _data["emailAddresses"])
                    this.emailAddresses.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentId"] = this.parentId;
        data["fileName"] = this.fileName;
        data["fileHash"] = this.fileHash;
        data["isProtected"] = this.isProtected;
        data["slug"] = this.slug;
        data["mimeType"] = this.mimeType;
        data["fileType"] = this.fileType;
        data["fileExtension"] = this.fileExtension;
        data["metadataText"] = this.metadataText;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["fileSize"] = this.fileSize;
        data["fileVersion"] = this.fileVersion;
        data["type"] = this.type;
        data["createdBy"] = this.createdBy;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["version"] = this.version;
        data["_meta"] = this._meta ? this._meta.toJSON() : undefined;
        data["isImage"] = this.isImage;
        data["pixelWidth"] = this.pixelWidth;
        data["pixelHeight"] = this.pixelHeight;
        data["newStatus"] = this.newStatus;
        data["statusColor"] = this.statusColor;
        data["newStatusColor"] = this.newStatusColor;
        data["briefDescription"] = this.briefDescription;
        data["status"] = this.status;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["highlight"] = this.highlight;
        data["scheduleJob"] = this.scheduleJob ? this.scheduleJob.toJSON() : undefined;
        data["transcript"] = this.transcript;
        data["isPending"] = this.isPending;
        data["permissionSet"] = this.permissionSet ? this.permissionSet.toJSON() : undefined;
        data["notificationDetails"] = this.notificationDetails ? this.notificationDetails.toJSON() : undefined;
        data["isEncrypted"] = this.isEncrypted;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}
export var AssetType;
(function (AssetType) {
    AssetType["Unknown"] = "Unknown";
    AssetType["Image"] = "Image";
    AssetType["Audio"] = "Audio";
    AssetType["Video"] = "Video";
})(AssetType || (AssetType = {}));
export class AssetMeta {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isDuplicate = _data["isDuplicate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetMeta();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isDuplicate"] = this.isDuplicate;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AssetMeta();
        result.init(json);
        return result;
    }
}
export class AnnotateAssetDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.slug = _data["slug"];
            this.isProtected = _data["isProtected"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            if (_data["metadata"]) {
                this.metadata = {};
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [];
                for (let item of _data["categories"])
                    this.categories.push(Category.fromJS(item));
            }
            this.permissionSet = _data["permissionSet"] ? PermissionSet.fromJS(_data["permissionSet"]) : undefined;
            if (Array.isArray(_data["emailAddresses"])) {
                this.emailAddresses = [];
                for (let item of _data["emailAddresses"])
                    this.emailAddresses.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AnnotateAssetDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["slug"] = this.slug;
        data["isProtected"] = this.isProtected;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["permissionSet"] = this.permissionSet ? this.permissionSet.toJSON() : undefined;
        if (Array.isArray(this.emailAddresses)) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AnnotateAssetDto();
        result.init(json);
        return result;
    }
}
export class ChangeAssetStatusDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
            this.dueTime = _data["dueTime"] ? new Date(_data["dueTime"].toString()) : undefined;
            this.notificationDetails = _data["notificationDetails"] ? NotificationDetails.fromJS(_data["notificationDetails"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeAssetStatusDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["dueTime"] = this.dueTime ? this.dueTime.toISOString() : undefined;
        data["notificationDetails"] = this.notificationDetails ? this.notificationDetails.toJSON() : undefined;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ChangeAssetStatusDto();
        result.init(json);
        return result;
    }
}
export class AssetSuggestionResults {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.transcript = _data["transcript"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssetSuggestionResults();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["transcript"] = this.transcript;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AssetSuggestionResults();
        result.init(json);
        return result;
    }
}
export class ClientsDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ClientDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClientsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ClientsDto();
        result.init(json);
        return result;
    }
}
export class ClientDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.secret = _data["secret"];
            this.name = _data["name"];
            this.role = _data["role"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["secret"] = this.secret;
        data["name"] = this.name;
        data["role"] = this.role;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ClientDto();
        result.init(json);
        return result;
    }
}
export class CreateClientDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CreateClientDto();
        result.init(json);
        return result;
    }
}
export class UpdateClientDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.role = _data["role"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["role"] = this.role;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateClientDto();
        result.init(json);
        return result;
    }
}
export class ContributorsDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ContributorDto.fromJS(item));
            }
            this.maxContributors = _data["maxContributors"];
            this._meta = _data["_meta"] ? ContributorsMetadata.fromJS(_data["_meta"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContributorsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["maxContributors"] = this.maxContributors;
        data["_meta"] = this._meta ? this._meta.toJSON() : undefined;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContributorsDto();
        result.init(json);
        return result;
    }
}
export class ContributorDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.contributorId = _data["contributorId"];
            this.contributorName = _data["contributorName"];
            this.contributorEmail = _data["contributorEmail"];
            this.role = _data["role"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContributorDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["contributorId"] = this.contributorId;
        data["contributorName"] = this.contributorName;
        data["contributorEmail"] = this.contributorEmail;
        data["role"] = this.role;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContributorDto();
        result.init(json);
        return result;
    }
}
export class ContributorsMetadata {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isInvited = _data["isInvited"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ContributorsMetadata();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isInvited"] = this.isInvited;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new ContributorsMetadata();
        result.init(json);
        return result;
    }
}
export class AssignContributorDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.contributorId = _data["contributorId"];
            this.role = _data["role"];
            this.invite = _data["invite"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AssignContributorDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["contributorId"] = this.contributorId;
        data["role"] = this.role;
        data["invite"] = this.invite;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AssignContributorDto();
        result.init(json);
        return result;
    }
}
export class AppLanguagesDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(AppLanguageDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AppLanguagesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AppLanguagesDto();
        result.init(json);
        return result;
    }
}
export class AppLanguageDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.fallback = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.iso2Code = _data["iso2Code"];
            this.englishName = _data["englishName"];
            if (Array.isArray(_data["fallback"])) {
                this.fallback = [];
                for (let item of _data["fallback"])
                    this.fallback.push(item);
            }
            this.isMaster = _data["isMaster"];
            this.isOptional = _data["isOptional"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AppLanguageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["iso2Code"] = this.iso2Code;
        data["englishName"] = this.englishName;
        if (Array.isArray(this.fallback)) {
            data["fallback"] = [];
            for (let item of this.fallback)
                data["fallback"].push(item);
        }
        data["isMaster"] = this.isMaster;
        data["isOptional"] = this.isOptional;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AppLanguageDto();
        result.init(json);
        return result;
    }
}
export class AddLanguageDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.language = _data["language"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddLanguageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AddLanguageDto();
        result.init(json);
        return result;
    }
}
export class UpdateLanguageDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isMaster = _data["isMaster"];
            this.isOptional = _data["isOptional"];
            if (Array.isArray(_data["fallback"])) {
                this.fallback = [];
                for (let item of _data["fallback"])
                    this.fallback.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isMaster"] = this.isMaster;
        data["isOptional"] = this.isOptional;
        if (Array.isArray(this.fallback)) {
            data["fallback"] = [];
            for (let item of this.fallback)
                data["fallback"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateLanguageDto();
        result.init(json);
        return result;
    }
}
export class PatternsDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(PatternDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatternsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new PatternsDto();
        result.init(json);
        return result;
    }
}
export class PatternDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pattern = _data["pattern"];
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PatternDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pattern"] = this.pattern;
        data["message"] = this.message;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new PatternDto();
        result.init(json);
        return result;
    }
}
export class UpdatePatternDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.pattern = _data["pattern"];
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatternDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["pattern"] = this.pattern;
        data["message"] = this.message;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdatePatternDto();
        result.init(json);
        return result;
    }
}
export class RolesDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RolesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new RolesDto();
        result.init(json);
        return result;
    }
}
export class RoleDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.permissions = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.numClients = _data["numClients"];
            this.numContributors = _data["numContributors"];
            this.isDefaultRole = _data["isDefaultRole"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [];
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["numClients"] = this.numClients;
        data["numContributors"] = this.numContributors;
        data["isDefaultRole"] = this.isDefaultRole;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}
export class AddRoleDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AddRoleDto();
        result.init(json);
        return result;
    }
}
export class UpdateRoleDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [];
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateRoleDto();
        result.init(json);
        return result;
    }
}
export class AppDto extends Resource {
    constructor(data) {
        super(data);
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.version = _data["version"];
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [];
                for (let item of _data["permissions"])
                    this.permissions.push(item);
            }
            this.canAccessApi = _data["canAccessApi"];
            this.canAccessContent = _data["canAccessContent"];
            this.planName = _data["planName"];
            this.planUpgrade = _data["planUpgrade"];
            this.isSuperUser = _data["isSuperUser"];
            this.allowEncryption = _data["allowEncryption"];
            this.defaultRole = _data["defaultRole"];
            this.canAccessSettings = _data["canAccessSettings"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AppDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["label"] = this.label;
        data["description"] = this.description;
        data["version"] = this.version;
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["canAccessApi"] = this.canAccessApi;
        data["canAccessContent"] = this.canAccessContent;
        data["planName"] = this.planName;
        data["planUpgrade"] = this.planUpgrade;
        data["isSuperUser"] = this.isSuperUser;
        data["allowEncryption"] = this.allowEncryption;
        data["defaultRole"] = this.defaultRole;
        data["canAccessSettings"] = this.canAccessSettings;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AppDto();
        result.init(json);
        return result;
    }
}
export class CreateAppDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.template = _data["template"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["template"] = this.template;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new CreateAppDto();
        result.init(json);
        return result;
    }
}
export class UpdateAppDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.label = _data["label"];
            this.description = _data["description"];
            this.defaultRole = _data["defaultRole"];
            this.allowEncryption = _data["allowEncryption"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["description"] = this.description;
        data["defaultRole"] = this.defaultRole;
        data["allowEncryption"] = this.allowEncryption;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateAppDto();
        result.init(json);
        return result;
    }
}
export class WorkflowsDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.items = [];
            this.errors = [];
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(WorkflowDto.fromJS(item));
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new WorkflowsDto();
        result.init(json);
        return result;
    }
}
export class WorkflowDto extends Resource {
    constructor(data) {
        super(data);
        if (!data) {
            this.steps = {};
        }
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (_data["steps"]) {
                this.steps = {};
                for (let key in _data["steps"]) {
                    if (_data["steps"].hasOwnProperty(key))
                        this.steps[key] = _data["steps"][key] ? WorkflowStepDto.fromJS(_data["steps"][key]) : new WorkflowStepDto();
                }
            }
            if (Array.isArray(_data["contentTypeIds"])) {
                this.contentTypeIds = [];
                for (let item of _data["contentTypeIds"])
                    this.contentTypeIds.push(item);
            }
            this.initial = _data["initial"];
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.steps) {
            data["steps"] = {};
            for (let key in this.steps) {
                if (this.steps.hasOwnProperty(key))
                    data["steps"][key] = this.steps[key] ? this.steps[key].toJSON() : undefined;
            }
        }
        if (Array.isArray(this.contentTypeIds)) {
            data["contentTypeIds"] = [];
            for (let item of this.contentTypeIds)
                data["contentTypeIds"].push(item);
        }
        data["initial"] = this.initial;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new WorkflowDto();
        result.init(json);
        return result;
    }
}
export class WorkflowStepDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.transitions = {};
        }
    }
    init(_data) {
        if (_data) {
            if (_data["transitions"]) {
                this.transitions = {};
                for (let key in _data["transitions"]) {
                    if (_data["transitions"].hasOwnProperty(key))
                        this.transitions[key] = _data["transitions"][key] ? WorkflowTransitionDto.fromJS(_data["transitions"][key]) : new WorkflowTransitionDto();
                }
            }
            this.color = _data["color"];
            this.noUpdate = _data["noUpdate"];
            this.noUpdateExpression = _data["noUpdateExpression"];
            if (Array.isArray(_data["noUpdateRoles"])) {
                this.noUpdateRoles = [];
                for (let item of _data["noUpdateRoles"])
                    this.noUpdateRoles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowStepDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (this.transitions) {
            data["transitions"] = {};
            for (let key in this.transitions) {
                if (this.transitions.hasOwnProperty(key))
                    data["transitions"][key] = this.transitions[key] ? this.transitions[key].toJSON() : undefined;
            }
        }
        data["color"] = this.color;
        data["noUpdate"] = this.noUpdate;
        data["noUpdateExpression"] = this.noUpdateExpression;
        if (Array.isArray(this.noUpdateRoles)) {
            data["noUpdateRoles"] = [];
            for (let item of this.noUpdateRoles)
                data["noUpdateRoles"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new WorkflowStepDto();
        result.init(json);
        return result;
    }
}
export class WorkflowTransitionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.expression = _data["expression"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [];
                for (let item of _data["roles"])
                    this.roles.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowTransitionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new WorkflowTransitionDto();
        result.init(json);
        return result;
    }
}
export var WorkflowType;
(function (WorkflowType) {
    WorkflowType["Content"] = "Content";
    WorkflowType["Files"] = "Files";
})(WorkflowType || (WorkflowType = {}));
export class AddWorkflowDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkflowDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AddWorkflowDto();
        result.init(json);
        return result;
    }
}
export class UpdateWorkflowDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.steps = {};
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (_data["steps"]) {
                this.steps = {};
                for (let key in _data["steps"]) {
                    if (_data["steps"].hasOwnProperty(key))
                        this.steps[key] = _data["steps"][key] ? WorkflowStepDto.fromJS(_data["steps"][key]) : new WorkflowStepDto();
                }
            }
            if (Array.isArray(_data["contentTypeIds"])) {
                this.contentTypeIds = [];
                for (let item of _data["contentTypeIds"])
                    this.contentTypeIds.push(item);
            }
            this.initial = _data["initial"];
            this.type = _data["type"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkflowDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.steps) {
            data["steps"] = {};
            for (let key in this.steps) {
                if (this.steps.hasOwnProperty(key))
                    data["steps"][key] = this.steps[key] ? this.steps[key].toJSON() : undefined;
            }
        }
        if (Array.isArray(this.contentTypeIds)) {
            data["contentTypeIds"] = [];
            for (let item of this.contentTypeIds)
                data["contentTypeIds"].push(item);
        }
        data["initial"] = this.initial;
        data["type"] = this.type;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new UpdateWorkflowDto();
        result.init(json);
        return result;
    }
}
export class AppGroupDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.name = _data["name"];
            this.role = _data["role"];
            if (Array.isArray(_data["membersAdded"])) {
                this.membersAdded = [];
                for (let item of _data["membersAdded"])
                    this.membersAdded.push(GroupMembership.fromJS(item));
            }
            if (Array.isArray(_data["membersRemoved"])) {
                this.membersRemoved = [];
                for (let item of _data["membersRemoved"])
                    this.membersRemoved.push(GroupMembership.fromJS(item));
            }
            if (Array.isArray(_data["parentGroupsAdded"])) {
                this.parentGroupsAdded = [];
                for (let item of _data["parentGroupsAdded"])
                    this.parentGroupsAdded.push(GroupMembership.fromJS(item));
            }
            if (Array.isArray(_data["parentGroupsRemoved"])) {
                this.parentGroupsRemoved = [];
                for (let item of _data["parentGroupsRemoved"])
                    this.parentGroupsRemoved.push(GroupMembership.fromJS(item));
            }
            this.membershipsCount = _data["membershipsCount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AppGroupDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["name"] = this.name;
        data["role"] = this.role;
        if (Array.isArray(this.membersAdded)) {
            data["membersAdded"] = [];
            for (let item of this.membersAdded)
                data["membersAdded"].push(item.toJSON());
        }
        if (Array.isArray(this.membersRemoved)) {
            data["membersRemoved"] = [];
            for (let item of this.membersRemoved)
                data["membersRemoved"].push(item.toJSON());
        }
        if (Array.isArray(this.parentGroupsAdded)) {
            data["parentGroupsAdded"] = [];
            for (let item of this.parentGroupsAdded)
                data["parentGroupsAdded"].push(item.toJSON());
        }
        if (Array.isArray(this.parentGroupsRemoved)) {
            data["parentGroupsRemoved"] = [];
            for (let item of this.parentGroupsRemoved)
                data["parentGroupsRemoved"].push(item.toJSON());
        }
        data["membershipsCount"] = this.membershipsCount;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new AppGroupDto();
        result.init(json);
        return result;
    }
}
export class GroupMembership {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.isGroup = _data["isGroup"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMembership();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["isGroup"] = this.isGroup;
        return data;
    }
    clone() {
        const json = this.toJSON();
        let result = new GroupMembership();
        result.init(json);
        return result;
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    throw new ApiException(message, status, response, headers, result);
}
